import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useRef, useState, useCallback, useEffect, Fragment as Fragment$1 } from 'react';
import { Transition, Dialog, TransitionChild, DialogPanel, Menu, MenuButton, Popover, PopoverButton, PopoverPanel, DialogBackdrop, Listbox, ListboxButton } from '@headlessui/react';
import * as Hero24OutlineIcons from '@heroicons/react/24/outline';
import { ExclamationTriangleIcon, CheckCircleIcon, ExclamationCircleIcon as ExclamationCircleIcon$1 } from '@heroicons/react/24/outline';
import * as Hero20SolidIcons from '@heroicons/react/20/solid';
import { ChevronDownIcon, XMarkIcon, LockClosedIcon, ExclamationCircleIcon, ChevronDoubleLeftIcon, ChevronLeftIcon, EllipsisHorizontalIcon, ChevronRightIcon, ChevronDoubleRightIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import * as Hero16SolidIcons from '@heroicons/react/16/solid';
import * as Hero24SolidIcons from '@heroicons/react/24/solid';
import { extendTailwindMerge, twJoin } from 'tailwind-merge';
export { twJoin } from 'tailwind-merge';
import { NavLink, useLocation, Link } from 'react-router-dom';
import { createPortal } from 'react-dom';

function _array_like_to_array$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$3(arr, i) {
    return _array_with_holes$3(arr) || _iterable_to_array_limit$3(arr, i) || _unsupported_iterable_to_array$3(arr, i) || _non_iterable_rest$3();
}
function _unsupported_iterable_to_array$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$3(o, minLen);
}
function AcknowledgeModal(param) {
    var show = param.show, title = param.title, message = param.message, onCancel = param.onCancel, onConfirm = param.onConfirm;
    var cancelButtonRef = useRef(null);
    var _useState = _sliced_to_array$3(useState(false), 2), acknowledged = _useState[0], setAcknowledged = _useState[1];
    var handleConfirm = function() {
        onConfirm();
        setAcknowledged(false);
    };
    var handleCancel = function() {
        onCancel();
        setAcknowledged(false);
    };
    return /*#__PURE__*/ jsx(Transition, {
        show: show,
        children: /*#__PURE__*/ jsxs(Dialog, {
            as: "div",
            className: "tw-relative tw-z-[60]",
            initialFocus: cancelButtonRef,
            onClose: onCancel,
            children: [
                /*#__PURE__*/ jsx(TransitionChild, {
                    enter: "tw-ease-out tw-duration-300",
                    enterFrom: "tw-opacity-0",
                    enterTo: "tw-opacity-100",
                    leave: "tw-ease-in tw-duration-200",
                    leaveFrom: "tw-opacity-100",
                    leaveTo: "tw-opacity-0",
                    children: /*#__PURE__*/ jsx("div", {
                        className: "tw-fixed tw-inset-0 tw-bg-neutral-600 tw-bg-opacity-75 tw-transition-opacity"
                    })
                }),
                /*#__PURE__*/ jsx("div", {
                    className: "tw-fixed tw-inset-0 tw-z-50 tw-overflow-y-auto",
                    children: /*#__PURE__*/ jsx("div", {
                        className: "tw-flex tw-min-h-full tw-items-end tw-justify-center tw-p-4 tw-text-center sm:tw-items-center sm:tw-p-0",
                        children: /*#__PURE__*/ jsx(TransitionChild, {
                            enter: "tw-ease-out tw-duration-300",
                            enterFrom: "tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95",
                            enterTo: "tw-opacity-100 tw-translate-y-0 sm:tw-scale-100",
                            leave: "tw-ease-in tw-duration-200",
                            leaveFrom: "tw-opacity-100 tw-translate-y-0 sm:tw-scale-100",
                            leaveTo: "tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95",
                            children: /*#__PURE__*/ jsxs(DialogPanel, {
                                className: "tw-relative tw-transform tw-overflow-hidden tw-rounded-lg tw-bg-white tw-px-4 tw-pb-4 tw-pt-5 tw-text-left tw-shadow-xl tw-transition-all sm:tw-my-8 sm:tw-w-full sm:tw-max-w-lg sm:tw-p-6",
                                children: [
                                    /*#__PURE__*/ jsx("div", {
                                        className: "sm:tw-flex sm:tw-items-start",
                                        children: /*#__PURE__*/ jsxs("div", {
                                            className: "tw-mt-3 tw-text-center sm:tw-ml-4 sm:tw-mt-0 sm:tw-text-left",
                                            children: [
                                                /*#__PURE__*/ jsx(Dialog.Title, {
                                                    as: "h4",
                                                    className: "tw-font-extrabold tw-text-neutral-900",
                                                    children: title
                                                }),
                                                /*#__PURE__*/ jsx("div", {
                                                    className: "tw-mt-2",
                                                    children: /*#__PURE__*/ jsx("p", {
                                                        className: "tw-text-neutral-700",
                                                        children: message
                                                    })
                                                }),
                                                /*#__PURE__*/ jsxs("div", {
                                                    className: "tw-mt-5",
                                                    children: [
                                                        /*#__PURE__*/ jsx("input", {
                                                            id: "acknowledge",
                                                            type: "checkbox",
                                                            className: "tw-h-4 tw-w-4 tw-rounded tw-border-neutral-200 tw-bg-neutral-100 tw-text-blue-600 focus:tw-ring-blue-600 disabled:tw-border-dashed",
                                                            checked: acknowledged,
                                                            onChange: function() {
                                                                return setAcknowledged(!acknowledged);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ jsx("label", {
                                                            htmlFor: "acknowledge",
                                                            className: "tw-ml-2 tw-text-neutral-700",
                                                            children: "I acknowledge and accept the changes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ jsxs("div", {
                                        className: "tw-mt-5 sm:tw-mt-4 sm:tw-flex sm:tw-flex-row-reverse",
                                        children: [
                                            /*#__PURE__*/ jsx("button", {
                                                type: "button",
                                                className: "tw-btn-primary tw-btn-medium tw-w-full sm:tw-ml-3 sm:tw-w-auto",
                                                onClick: function() {
                                                    return handleConfirm();
                                                },
                                                disabled: !acknowledged,
                                                children: "Confirm"
                                            }),
                                            /*#__PURE__*/ jsx("button", {
                                                type: "button",
                                                className: "tw-btn-secondary-filled tw-btn-medium tw-mt-3 tw-w-full sm:tw-mt-0 sm:tw-w-auto",
                                                onClick: function() {
                                                    return handleCancel();
                                                },
                                                ref: cancelButtonRef,
                                                children: "Cancel"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

function DeleteModal(param) {
    var show = param.show, title = param.title, message = param.message, onCancel = param.onCancel, onDelete = param.onDelete;
    var cancelButtonRef = useRef(null);
    return /*#__PURE__*/ jsx(Transition, {
        show: show,
        children: /*#__PURE__*/ jsxs(Dialog, {
            as: "div",
            className: "tw-relative tw-z-[60]",
            initialFocus: cancelButtonRef,
            onClose: onCancel,
            children: [
                /*#__PURE__*/ jsx(TransitionChild, {
                    enter: "tw-ease-out tw-duration-300",
                    enterFrom: "tw-opacity-0",
                    enterTo: "tw-opacity-100",
                    leave: "tw-ease-in tw-duration-200",
                    leaveFrom: "tw-opacity-100",
                    leaveTo: "tw-opacity-0",
                    children: /*#__PURE__*/ jsx("div", {
                        className: "tw-fixed tw-inset-0 tw-bg-neutral-600 tw-bg-opacity-75 tw-transition-opacity"
                    })
                }),
                /*#__PURE__*/ jsx("div", {
                    className: "tw-fixed tw-inset-0 tw-z-50 tw-overflow-y-auto",
                    children: /*#__PURE__*/ jsx("div", {
                        className: "tw-flex tw-min-h-full tw-items-end tw-justify-center tw-p-4 tw-text-center sm:tw-items-center sm:tw-p-0",
                        children: /*#__PURE__*/ jsx(TransitionChild, {
                            enter: "tw-ease-out tw-duration-300",
                            enterFrom: "tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95",
                            enterTo: "tw-opacity-100 tw-translate-y-0 sm:tw-scale-100",
                            leave: "tw-ease-in tw-duration-200",
                            leaveFrom: "tw-opacity-100 tw-translate-y-0 sm:tw-scale-100",
                            leaveTo: "tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95",
                            children: /*#__PURE__*/ jsxs(DialogPanel, {
                                className: "tw-relative tw-transform tw-overflow-hidden tw-rounded-lg tw-bg-white tw-px-4 tw-pb-4 tw-pt-5 tw-text-left tw-shadow-xl tw-transition-all sm:tw-my-8 sm:tw-w-full sm:tw-max-w-lg sm:tw-p-6",
                                children: [
                                    /*#__PURE__*/ jsxs("div", {
                                        className: "sm:tw-flex sm:tw-items-start",
                                        children: [
                                            /*#__PURE__*/ jsx("div", {
                                                className: "tw-mx-auto tw-flex tw-h-12 tw-w-12 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-red-50 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10",
                                                children: /*#__PURE__*/ jsx(ExclamationTriangleIcon, {
                                                    className: "tw-h-6 tw-w-6 tw-text-red-700",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ jsxs("div", {
                                                className: "tw-mt-3 tw-text-center sm:tw-ml-4 sm:tw-mt-0 sm:tw-text-left",
                                                children: [
                                                    /*#__PURE__*/ jsx(Dialog.Title, {
                                                        as: "h3",
                                                        className: "tw-text-base tw-font-semibold tw-leading-6 tw-text-neutral-900",
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ jsx("div", {
                                                        className: "tw-mt-2",
                                                        children: /*#__PURE__*/ jsx("p", {
                                                            className: "tw-text-sm tw-text-neutral-500",
                                                            children: message
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ jsxs("div", {
                                        className: "tw-mt-5 sm:tw-mt-4 sm:tw-flex sm:tw-flex-row-reverse",
                                        children: [
                                            /*#__PURE__*/ jsx("button", {
                                                type: "button",
                                                className: "tw-btn-destructive tw-btn-medium tw-w-full sm:tw-ml-3 sm:tw-w-auto",
                                                onClick: function() {
                                                    return onDelete();
                                                },
                                                children: "Delete"
                                            }),
                                            /*#__PURE__*/ jsx("button", {
                                                type: "button",
                                                className: "tw-btn-secondary-filled tw-btn-medium tw-mt-3 tw-w-full sm:tw-mt-0 sm:tw-w-auto",
                                                onClick: function() {
                                                    return onCancel();
                                                },
                                                ref: cancelButtonRef,
                                                children: "Cancel"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    else for(t in e)e[t] && (n && (n += " "), n += t);
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}

/**
 * Default row renderer for dropdown items
 */ function makeRowItem(item) {
    var isSelected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            item.name,
            isSelected ? /*#__PURE__*/ jsx(CheckCircleIcon, {
                className: "tw-h-5 tw-w-5 tw-text-green-600",
                "aria-hidden": "true"
            }) : null
        ]
    });
}
function Dropdown(param) {
    var items = param.items, selectedItem = param.selectedItem, renderer = param.renderer, onSelected = param.onSelected;
    var rowRenderer = renderer || makeRowItem;
    var isSelected = function(item) {
        return item.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
    };
    return /*#__PURE__*/ jsxs(Menu, {
        as: "div",
        className: "tw-relative tw-leading-none",
        children: [
            /*#__PURE__*/ jsx("div", {
                children: /*#__PURE__*/ jsxs(MenuButton, {
                    className: "tw-btn-secondary-outline",
                    children: [
                        (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name) || "Options",
                        /*#__PURE__*/ jsx(ChevronDownIcon, {
                            className: "-tw-mr-1 tw-h-4 tw-w-4 tw-text-neutral-400",
                            "aria-hidden": "true"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ jsx(Transition, {
                enter: "tw-transition tw-ease-out tw-duration-100",
                enterFrom: "tw-transform tw-opacity-0 tw-scale-95",
                enterTo: "tw-transform tw-opacity-100 tw-scale-100",
                leave: "tw-transition tw-ease-in tw-duration-75",
                leaveFrom: "tw-transform tw-opacity-100 tw-scale-100",
                leaveTo: "tw-transform tw-opacity-0 tw-scale-95",
                children: /*#__PURE__*/ jsx(Menu.Items, {
                    className: "tw-absolute tw-right-0 tw-z-10 tw-mt-2 tw-w-56 tw-origin-top-right tw-rounded-xl tw-bg-white tw-text-sm tw-text-neutral-800 tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none",
                    children: /*#__PURE__*/ jsx("div", {
                        className: "tw-py-2",
                        children: items.map(function(item) {
                            return /*#__PURE__*/ jsx(Menu.Item, {
                                children: function(param) {
                                    var active = param.active;
                                    return /*#__PURE__*/ jsx("button", {
                                        onClick: function() {
                                            return onSelected === null || onSelected === void 0 ? void 0 : onSelected(item);
                                        },
                                        className: clsx(item.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) ? "tw-font-semibold" : "", active ? "tw-bg-neutral-100" : "", "tw-flex tw-w-full tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-text-left"),
                                        children: rowRenderer(item, isSelected(item))
                                    });
                                }
                            }, item.id);
                        })
                    })
                })
            })
        ]
    });
}

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties$1(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Icon = function(_param) {
    var icon = _param.icon, _param_type = _param.type, type = _param_type === void 0 ? "outline" : _param_type, tmp = _param.solidSize, size = tmp === void 0 ? "24" : tmp, props = _object_without_properties$1(_param, [
        "icon",
        "type",
        "solidSize"
    ]);
    var clearAndUpper = function(text) {
        return text.replace(/-/, "").toUpperCase();
    };
    var toPascalCase = function(text) {
        return text.replace(/(^\w|-\w)/g, clearAndUpper);
    };
    // Convert icon name from kebab-case to PascalCase
    var name = "".concat(toPascalCase(icon), "Icon");
    var Component = type === "outline" ? Hero24OutlineIcons[name] : size === "16" ? Hero16SolidIcons[name] : size === "20" ? Hero20SolidIcons[name] : Hero24SolidIcons[name];
    return /*#__PURE__*/ jsx(Component, _object_spread$2({}, props));
};

function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function calculateNumLines(props, rows) {
    var _props_value, _props_value1;
    var numCharsPerLine = 100; // @todo - calculate num chars per line based on font and width of field
    var calculateNumLines = function(text) {
        return (text || "").split(/\r\n|\r|\n/g).reduce(function(acc, line) {
            return acc + Math.ceil(line.length / numCharsPerLine);
        }, 0);
    };
    // If > 1, the input will be a textarea
    var textLength = ((_props_value = props.value) === null || _props_value === void 0 ? void 0 : _props_value.toString().length) || 0;
    var numRows = Math.max(calculateNumLines((_props_value1 = props.value) === null || _props_value1 === void 0 ? void 0 : _props_value1.toString()), Math.ceil(textLength / numCharsPerLine)) || 1;
    // TODO: Use textLength to determine if we should use textarea, but it's not working correctly; see [PD-89568]
    var useTextArea = (rows || 1) > 1; //  || textLength > numCharsPerLine;
    return {
        numRows: numRows,
        useTextArea: useTextArea,
        textLength: textLength
    };
}
/**
 * Input field that is a input or textarea depending on the number of rows and other criteria
 *
 * React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
 * React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>
 */ var Input = function(_param) {
    var labelText = _param.labelText, helperText = _param.helperText, errorText = _param.errorText, color = _param.color, mode = _param.mode, rows = _param.rows, props = _object_without_properties(_param, [
        "labelText",
        "helperText",
        "errorText",
        "color",
        "mode",
        "rows"
    ]);
    var _props_value;
    var textRef = useRef(null);
    var _calculateNumLines = calculateNumLines(props, rows), numRows = _calculateNumLines.numRows, useTextArea = _calculateNumLines.useTextArea, textLength = _calculateNumLines.textLength;
    var resetField = useCallback(// clear contents, validate, reset rows, and focus
    function(e) {
        var // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _props_onChange;
        if (!props.id) {
            return;
        }
        (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, {
            target: {
                name: props.id,
                value: ""
            }
        });
        var el = textRef.current;
        if (el && _instanceof(el, HTMLTextAreaElement)) {
            el.rows = 1;
        }
        el === null || el === void 0 ? void 0 : el.focus();
    }, [
        textRef,
        props
    ]);
    return /*#__PURE__*/ jsxs("div", {
        className: clsx("tw-relative tw-z-0 tw-w-full group", errorText ? "has-error" : ""),
        children: [
            useTextArea ? /*#__PURE__*/ jsx("textarea", _object_spread_props$1(_object_spread$1({}, props), {
                ref: textRef,
                className: clsx("tw-mt-4 tw-block tw-w-full tw-appearance-none tw-border-0 tw-border-b-2 tw-border-neutral-200 tw-bg-transparent tw-px-0 tw-py-1 tw-text-neutral-800 tw-placeholder-neutral-600 placeholder:tw-opacity-0 focus:tw-outline-none focus:tw-ring-0 focus:placeholder:tw-opacity-100 disabled:tw-cursor-not-allowed disabled:tw-border-dashed disabled:tw-bg-neutral-100 [.group.has-error_&]:tw-border-red-200 [.group.has-error_&]:tw-text-red-800 [.group.has-error_&]:tw-placeholder-red-600 focus:[.group.has-error_&]:tw-border-red-800 dark:tw-border-neutral-700 dark:tw-text-neutral-100 dark:tw-placeholder-neutral-400 dark:disabled:tw-bg-neutral-800 dark:[.group.has-error_&]:tw-border-red-700 dark:[.group.has-error_&]:tw-text-red-100 dark:[.group.has-error_&]:tw-placeholder-red-400 dark:focus:[.group.has-error_&]:tw-border-red-700 [.group.has-error_&]:[&:not(:focus)]:tw-pr-6 focus:[&:not(:placeholder-shown)]:tw-pr-6 group-hover:[&:not(:placeholder-shown)]:tw-pr-6 peer", color === "purple" ? "focus:tw-border-blue-700 dark:focus:tw-border-blue-600" : "focus:tw-border-purple-700 dark:focus:tw-border-purple-600", mode === "large" ? "tw-text-3xl tw-font-bold" : "", props.className),
                placeholder: props.placeholder || " ",
                rows: numRows
            })) : /*#__PURE__*/ jsx("input", _object_spread_props$1(_object_spread$1({}, props), {
                ref: textRef,
                className: clsx("tw-mt-4 tw-block tw-w-full tw-appearance-none tw-border-0 tw-border-b-2 tw-border-neutral-200 tw-bg-transparent tw-px-0 tw-py-1 tw-text-neutral-800 tw-placeholder-neutral-600 placeholder:tw-opacity-0 focus:tw-outline-none focus:tw-ring-0 focus:placeholder:tw-opacity-100 disabled:tw-cursor-not-allowed disabled:tw-border-dashed disabled:tw-bg-neutral-100 [.group.has-error_&]:tw-border-red-200 [.group.has-error_&]:tw-text-red-800 [.group.has-error_&]:tw-placeholder-red-600 focus:[.group.has-error_&]:tw-border-red-800 dark:tw-border-neutral-700 dark:tw-text-neutral-100 dark:tw-placeholder-neutral-400 dark:disabled:tw-bg-neutral-800 dark:[.group.has-error_&]:tw-border-red-700 dark:[.group.has-error_&]:tw-text-red-100 dark:[.group.has-error_&]:tw-placeholder-red-400 dark:focus:[.group.has-error_&]:tw-border-red-700 [.group.has-error_&]:[&:not(:focus)]:tw-pr-6 focus:[&:not(:placeholder-shown)]:tw-pr-6 group-hover:[&:not(:placeholder-shown)]:tw-pr-6 peer", color === "purple" ? "focus:tw-border-blue-700 dark:focus:tw-border-blue-600" : "focus:tw-border-purple-700 dark:focus:tw-border-purple-600", mode === "large" ? "tw-text-3xl tw-font-bold" : "", props.className),
                placeholder: props.placeholder || " "
            })),
            /*#__PURE__*/ jsxs("label", {
                htmlFor: props.id,
                className: clsx("tw-absolute tw-top-1 tw-origin-[0] -tw-translate-y-5 tw-transform tw-text-xs tw-font-semibold tw-text-neutral-600 tw-duration-300 group-hover:tw-text-neutral-800 [.group.has-error_&]:tw-text-red-600 group-hover:[.group.has-error_&]:tw-text-red-800 peer-placeholder-shown:tw-translate-y-0 peer-focus:tw-left-0 peer-focus:-tw-translate-y-5 peer-focus:tw-text-xs peer-focus:tw-font-semibold [.group.has-error_&]:peer-focus:tw-text-red-800 peer-disabled:tw-cursor-not-allowed dark:tw-text-neutral-300 dark:group-hover:tw-text-neutral-200 dark:[.group.has-error_&]:tw-text-red-400 dark:group-hover:[.group.has-error_&]:tw-text-red-300 dark:[.group.has-error_&]:peer-focus:tw-text-red-400", color === "purple" ? "peer-focus:tw-text-blue-700 dark:peer-focus:tw-text-blue-600" : "peer-focus:tw-text-purple-700 dark:peer-focus:tw-text-purple-600", mode === "large" ? "peer-placeholder-shown:tw-text-3xl peer-placeholder-shown:tw-font-bold" : "peer-placeholder-shown:tw-text-base peer-placeholder-shown:tw-font-normal"),
                children: [
                    labelText,
                    props.required ? /*#__PURE__*/ jsx("span", {
                        "aria-hidden": "true",
                        className: "tw-text-red-800",
                        children: "\xa0*"
                    }) : null
                ]
            }),
            /*#__PURE__*/ jsx("button", {
                type: "button",
                className: "tw-absolute tw-bottom-5 tw-right-0 tw-top-0 tw-z-10 tw-hidden tw-items-center focus:tw-flex peer-focus:[.peer:not(:placeholder-shown)_&]:tw-flex group-hover:peer-enabled:[.peer:not(:placeholder-shown)_&]:tw-flex dark:tw-text-neutral-300",
                onClick: resetField,
                children: /*#__PURE__*/ jsx(XMarkIcon, {
                    className: "tw-h-4 tw-w-4"
                })
            }),
            /*#__PURE__*/ jsx("div", {
                className: clsx("tw-pointer-events-none tw-absolute tw-bottom-5 tw-right-0 tw-top-0 tw-items-center", props.disabled ? "tw-flex" : "tw-hidden"),
                children: /*#__PURE__*/ jsx(LockClosedIcon, {
                    className: "tw-h-4 tw-w-4 tw-text-neutral-600"
                })
            }),
            /*#__PURE__*/ jsx("div", {
                className: "tw-pointer-events-none tw-absolute tw-bottom-5 tw-right-0 tw-top-0 tw-hidden tw-items-center group-hover:tw-hidden [.group.has-error_&]:tw-flex peer-focus:tw-hidden peer-focus:[.peer:not(:placeholder-shown)_&]:tw-!hidden group-hover:peer-enabled:[.peer:not(:placeholder-shown)_&]:tw-!hidden",
                children: /*#__PURE__*/ jsx(ExclamationCircleIcon, {
                    className: "tw-h-4 tw-w-4 tw-text-red-600"
                })
            }),
            /*#__PURE__*/ jsxs("p", {
                className: "tw-h-5 tw-pt-1 tw-text-xs tw-text-neutral-600 [.group.has-error_&]:tw-text-red-600 dark:tw-text-neutral-300 dark:[.group.has-error_&]:tw-text-red-300",
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: clsx(helperText && props.disabled ? "tw-italic" : ""),
                        children: errorText || helperText
                    }),
                    props.maxLength && textLength > 100 ? /*#__PURE__*/ jsxs("span", {
                        className: "tw-float-right",
                        children: [
                            /*#__PURE__*/ jsx("span", {
                                children: (_props_value = props.value) === null || _props_value === void 0 ? void 0 : _props_value.toString().length
                            }),
                            "/",
                            props.maxLength
                        ]
                    }) : null
                ]
            })
        ]
    });
};

/**
 * Tailwind Merge extended with custom prefix to match the Tailwind CSS configuration.
 * Note: Developers should import this function to use Tailwind Merge instead of the original one from 'tailwind-merge'.
 * @example
 * import { twMerge } from '@degreed/apollo-angular';
 */ var twMerge = extendTailwindMerge({
    prefix: "tw-"
});

var ACTION_KEY_DEFAULT = [
    "Ctrl ",
    "Control",
    {
        ctrlKey: true
    }
];
var ACTION_KEY_APPLE = [
    "⌘",
    "Command",
    {
        metaKey: true
    }
];
/**
 * Get the action key for the current platform.
 * @returns Either Ctrl or ⌘ depending on the platform.
 */ function useActionKey() {
    var actionKey = ACTION_KEY_DEFAULT;
    if (typeof navigator !== "undefined") {
        if (/(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
            actionKey = ACTION_KEY_APPLE;
        }
    }
    return actionKey;
}

var Footer = function(param) {
    var footerBranding = param.footerBranding, className = param.className;
    return (footerBranding === null || footerBranding === void 0 ? void 0 : footerBranding.enabled) && (footerBranding === null || footerBranding === void 0 ? void 0 : footerBranding.visible) ? /*#__PURE__*/ jsxs("footer", {
        className: twMerge("tw-flex tw-items-center tw-justify-center tw-gap-2 tw-py-10 tw-text-xs", className),
        children: [
            /*#__PURE__*/ jsx("span", {
                className: "tw-font-semibold",
                children: footerBranding.text
            }),
            /*#__PURE__*/ jsxs("svg", {
                className: "tw-h-8",
                viewBox: "0 0 74 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        d: "M16.9962 14.1663C16.5057 14.5826 15.9021 14.8474 15.2231 14.8474C14.2422 14.8853 13.5631 14.7717 13.1859 13.9393C12.62 12.7663 12.9218 12.0474 12.9595 11.9339C13.4122 11.0258 16.883 10.7987 17.2225 11.5177C17.4489 11.896 17.5243 13.6366 16.9962 14.1663ZM8.88518 13.9393C8.50793 14.7717 7.82887 14.8853 6.84801 14.8474C6.20667 14.8474 5.56534 14.6204 5.0749 14.1663C4.58447 13.5988 4.6222 11.896 4.81083 11.5177C5.18808 10.7987 8.62111 11.0258 9.07381 11.9339C9.14926 12.0474 9.45107 12.7663 8.88518 13.9393ZM18.8447 10.2312L13.865 7.50681L13.7141 7.3933C13.4122 7.27978 13.1104 7.27978 12.8464 7.3933L12.6577 7.50681L11.8655 7.96087V7.99871L12.1673 8.15006L14.0536 9.17169L15.1476 9.7771C14.0536 9.85278 12.9595 10.1933 12.0164 10.7231C11.7523 10.8744 11.4128 10.9879 11.111 10.9879H11.0355C10.696 10.9879 10.3942 10.9122 10.1301 10.7231C9.14926 10.1933 8.09295 9.85278 6.99891 9.7771L11.0733 7.50681L12.5446 6.67437C12.9218 6.4095 13.3745 6.33383 13.8272 6.44734C14.2045 6.59869 14.544 6.75005 14.8835 6.97708C15.0344 7.05275 15.1853 7.09059 15.3363 7.05275C15.4872 7.01491 15.6003 6.93924 15.7135 6.82572C15.8267 6.71221 15.8644 6.52302 15.8644 6.37166C15.8644 6.14463 15.7512 5.91761 15.5249 5.76625C15.0344 5.42571 14.4686 5.19868 13.865 5.04733C12.5068 4.8203 11.6391 5.46355 10.9978 5.84193C10.2056 5.19868 9.14926 4.89598 8.13067 5.04733C7.52707 5.19868 6.99891 5.42571 6.47075 5.76625C6.16895 5.99328 6.05577 6.4095 6.28212 6.71221C6.28212 6.75005 6.31985 6.75005 6.31985 6.78788C6.47075 6.93924 6.65938 7.01491 6.84801 7.01491C6.96118 7.01491 7.07436 6.97708 7.18754 6.9014C7.52707 6.71221 7.86659 6.52302 8.24385 6.37166C8.69656 6.25815 9.18699 6.37166 9.56424 6.63653L3.26408 10.2312C3.11318 10.3068 3 10.496 3 10.6852V11.5555C3 11.7447 3.11318 11.9339 3.26408 12.0096C3.41498 12.0852 3.45271 12.1609 3.45271 12.4636C3.45271 13.0312 3.07545 16.0582 7.03663 16.0582C10.5828 16.0582 10.1679 12.5771 11.0355 12.5771C11.9032 12.5771 11.4882 16.0582 15.0344 16.0582C18.9956 16.0582 18.6184 13.0312 18.6184 12.4636C18.6184 12.1609 18.6561 12.0852 18.807 12.0096C18.9956 11.9339 19.1088 11.7447 19.1088 11.5555V10.6852C19.1465 10.496 19.0334 10.3068 18.8447 10.2312Z",
                        fill: "#0062E3"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M39.1411 12.4636C39.1788 12.1231 39.3297 11.8204 39.5938 11.5933C39.971 11.2906 40.4237 11.1393 40.9142 11.1771C41.3669 11.1393 41.8196 11.2906 42.1591 11.5933C42.4232 11.8204 42.5741 12.1609 42.6118 12.5015V12.9177C42.6118 13.2582 42.4986 13.5988 42.2723 13.8636C42.2346 13.9015 42.1968 13.9771 42.1214 14.015C41.9705 14.1663 41.7441 14.2798 41.5555 14.3555C41.3291 14.4312 41.0651 14.469 40.801 14.469C40.3483 14.5069 39.8956 14.3555 39.556 14.015C39.5183 13.9771 39.4429 13.9393 39.4051 13.8636C39.1788 13.5609 39.0656 13.1825 39.1033 12.8042C39.1033 12.6906 39.1033 12.5771 39.1411 12.4636ZM44.0831 10.042H42.8382C42.8004 10.042 42.7627 10.0798 42.725 10.1176C42.6873 10.1555 42.6873 10.1933 42.6873 10.2312V10.8366C42.4609 10.5339 42.1214 10.269 41.7819 10.1176C41.3669 9.96629 40.9519 9.89062 40.4992 9.89062C39.9333 9.89062 39.4051 10.0041 38.9147 10.269C38.462 10.496 38.1225 10.8744 37.8584 11.3285C37.5943 11.7825 37.4811 12.3123 37.4811 12.842C37.4811 13.3339 37.5943 13.8258 37.7829 14.2798L37.8584 14.3555C38.0847 14.7717 38.462 15.1123 38.877 15.3772C39.0656 15.4907 39.292 15.5663 39.5183 15.642C39.7824 15.7177 40.0465 15.7555 40.3483 15.7177C40.6501 15.7177 40.9519 15.6799 41.2537 15.642C41.4046 15.6042 41.5555 15.5285 41.7064 15.4907C42.0837 15.3393 42.4232 15.0744 42.6873 14.7717V15.6799C42.6873 15.9447 42.6118 16.2096 42.4609 16.4366C42.31 16.6637 42.0837 16.8528 41.8196 16.9664C41.6309 17.042 41.4423 17.1177 41.2537 17.1177C41.1028 17.1177 40.9896 17.1555 40.8387 17.1555C40.0088 17.1555 39.4806 16.9285 39.2165 16.4366C39.2165 16.3988 39.1788 16.3609 39.1411 16.3609H37.8207C37.7452 16.3609 37.6698 16.4366 37.6698 16.5123V16.5501C37.8207 17.1177 38.1602 17.5718 38.6506 17.9123C39.3297 18.2907 40.0842 18.442 40.8764 18.4042C41.48 18.442 42.0837 18.2907 42.6495 18.0637C42.6873 18.0637 42.6873 18.0258 42.725 18.0258C42.9891 17.9123 43.2154 17.761 43.404 17.5718C43.9322 17.0799 44.234 16.3988 44.2717 15.6799C44.3095 15.4528 44.3095 15.2258 44.3095 15.0366V10.2312C44.2717 10.1176 44.1963 10.042 44.0831 10.042ZM70.3401 13.1069C70.3401 13.5231 70.1892 13.9393 69.8874 14.2042C69.7365 14.3555 69.5101 14.5069 69.2838 14.5826C69.0574 14.6582 68.7933 14.7339 68.567 14.7339C68.1143 14.7717 67.6238 14.5825 67.322 14.2798C66.9825 13.9393 66.8316 13.4474 66.8693 12.9555C66.8316 12.4636 66.9825 11.9717 67.322 11.5933C67.6993 11.2528 68.152 11.1014 68.6424 11.1393C69.0951 11.1014 69.5856 11.2906 69.8874 11.5933C70.0383 11.7447 70.1515 11.9339 70.2269 12.1231C70.3024 12.3501 70.3401 12.5393 70.3401 12.7663V13.1069ZM71.7737 7.96087H70.491C70.4533 7.96087 70.4155 7.96087 70.3778 7.99871C70.3401 8.03654 70.3401 8.07438 70.3401 8.11222V10.7609C69.8119 10.1176 69.0197 9.7771 68.1897 9.81494C67.6238 9.81494 67.0957 9.92845 66.6053 10.2312C66.1525 10.496 65.7753 10.8744 65.5489 11.3285C65.2849 11.8204 65.1717 12.3879 65.2094 12.9555C65.2094 13.5231 65.3226 14.0528 65.5489 14.5447C65.7753 14.9988 66.1148 15.3393 66.5675 15.6042C67.0202 15.869 67.5107 15.9826 68.0388 15.9826C68.5293 15.9826 68.982 15.9069 69.3969 15.7177C69.8119 15.5663 70.1515 15.2636 70.3778 14.9231V15.642C70.3778 15.7555 70.4533 15.8312 70.5664 15.8312H71.8114C71.9246 15.8312 72 15.7555 72 15.642V8.15006C72 8.11222 72 8.03655 71.9623 8.03655C71.8868 7.99871 71.8491 7.96087 71.7737 7.96087ZM59.211 12.3123C59.2488 11.9339 59.4374 11.5933 59.7392 11.4041C60.0787 11.1393 60.4937 11.0258 60.9087 11.0258C61.3614 10.9879 61.7764 11.1014 62.1536 11.3663C62.4554 11.5933 62.6441 11.9339 62.6063 12.3123H59.211ZM63.3609 10.6474C62.6818 10.1176 61.8141 9.81494 60.9464 9.89062C60.3428 9.89062 59.7392 10.0041 59.1733 10.3068C58.6829 10.5717 58.2679 10.9501 58.0038 11.442C57.7398 11.9339 57.5889 12.5015 57.5889 13.069C57.5511 13.9015 57.8529 14.6961 58.4565 15.2636C59.1356 15.8312 60.0033 16.0961 60.9087 16.0582C61.6632 16.0961 62.4177 15.9447 63.0968 15.5663C63.5872 15.2636 63.9267 14.8096 64.0776 14.242C64.1154 14.1663 64.0776 14.0907 64.0022 14.0907H62.6818C62.6441 14.0907 62.5686 14.1285 62.5686 14.1663C62.3423 14.6204 61.8141 14.8853 61.0219 14.8853C60.7201 14.8853 60.3805 14.8096 60.0787 14.6961C59.8147 14.5826 59.626 14.3934 59.4374 14.1663C59.2865 13.9393 59.211 13.6744 59.211 13.4096H64.0022C64.0776 13.4096 64.1154 13.3717 64.1531 13.3339C64.1908 13.2961 64.2285 13.2204 64.2285 13.1825V12.8798C64.2663 12.0474 63.9267 11.2528 63.3609 10.6474ZM51.7037 12.3123C51.7414 11.9339 51.93 11.5933 52.2318 11.4041C52.5714 11.1393 52.9863 11.0258 53.4013 11.0258C53.854 10.9879 54.269 11.1014 54.6463 11.3663C54.9481 11.5933 55.1367 11.9339 55.099 12.3123H51.7037ZM55.8158 10.6474C55.1367 10.1176 54.269 9.81494 53.4013 9.89062C52.7977 9.89062 52.1941 10.0041 51.6282 10.3068C51.1378 10.5717 50.7228 10.9501 50.4587 11.442C50.1946 11.9339 50.0437 12.5015 50.0437 13.069C50.006 13.9015 50.3078 14.6961 50.9114 15.2636C51.5905 15.8312 52.4582 16.0961 53.3636 16.0582C54.1181 16.0961 54.8726 15.9447 55.5517 15.5663C56.0421 15.2636 56.3816 14.8096 56.5325 14.242C56.5703 14.1663 56.5325 14.0907 56.4571 14.0907H55.1367C55.099 14.0907 55.0235 14.1285 55.0235 14.1663C54.7972 14.6204 54.269 14.8853 53.4768 14.8853C53.175 14.8853 52.8354 14.8096 52.5336 14.6961C52.2696 14.5826 52.0809 14.3934 51.8923 14.1663C51.7414 13.9393 51.6659 13.6744 51.6659 13.4096H56.4571C56.5325 13.4096 56.5703 13.3717 56.608 13.3339C56.6457 13.2961 56.6834 13.2204 56.6834 13.1825V12.8798C56.7212 12.0474 56.4194 11.2528 55.8158 10.6474ZM49.3647 9.96629C48.5347 9.96629 47.7802 10.3447 47.2521 10.9879V10.2312C47.2521 10.1933 47.2521 10.1555 47.2143 10.1176C47.1766 10.0798 47.1389 10.0798 47.1012 10.042H45.8562C45.743 10.042 45.6676 10.1176 45.6676 10.2312V15.6799C45.6676 15.7934 45.743 15.869 45.8562 15.869H47.1389C47.2521 15.869 47.3275 15.7934 47.3275 15.6799V12.8042C47.3275 12.4258 47.5161 12.0474 47.8179 11.7825C48.1952 11.4798 48.6856 11.2906 49.1761 11.3285H49.4024C49.5156 11.3285 49.6288 11.2528 49.6288 11.1393V10.1555C49.6288 10.1176 49.591 10.042 49.5533 10.0041C49.5156 9.96629 49.4779 9.92845 49.4024 9.92845H49.3647V9.96629ZM31.5205 12.3501C31.5582 11.9717 31.7469 11.6312 32.0487 11.442C32.3882 11.1771 32.8032 11.0636 33.2182 11.0636C33.6709 11.0258 34.0858 11.1393 34.4631 11.4041C34.7649 11.6312 34.9158 11.9717 34.9158 12.3501H31.5205ZM35.6703 10.6474C34.9913 10.0798 34.1613 9.81494 33.2936 9.85278C32.69 9.85278 32.0864 9.96629 31.5205 10.269C31.0301 10.5339 30.6151 10.9122 30.351 11.4041C30.0869 11.896 29.936 12.4636 29.936 13.0312C29.8983 13.8636 30.2001 14.6582 30.8037 15.2258C31.4828 15.7934 32.3505 16.0582 33.2559 16.0204C34.0104 16.0582 34.7649 15.9069 35.444 15.5285C35.9344 15.2258 36.2739 14.7717 36.4248 14.2042C36.4626 14.1285 36.3871 14.0528 36.3494 14.0528H35.029C34.9913 14.0528 34.9158 14.0907 34.9158 14.1285C34.6895 14.5826 34.1613 14.8474 33.3313 14.8474C33.0295 14.8474 32.69 14.7717 32.3882 14.6582C32.1241 14.5447 31.9355 14.3555 31.7469 14.1285C31.596 13.9015 31.5205 13.6366 31.5205 13.3717H36.2739C36.3494 13.3717 36.3871 13.3339 36.4248 13.2961C36.4626 13.2582 36.5003 13.1825 36.5003 13.1447V12.8798C36.538 12.0474 36.2362 11.2528 35.6703 10.6474ZM27.2575 13.1069C27.2575 13.2961 27.2198 13.5231 27.1443 13.7123C27.0689 13.9015 26.9557 14.0907 26.8048 14.242C26.6539 14.3934 26.4276 14.5447 26.2012 14.6204C25.9749 14.6961 25.7108 14.7717 25.4467 14.7717C24.994 14.8096 24.5036 14.6204 24.2018 14.3177C23.8622 13.9771 23.7113 13.4852 23.749 13.0312C23.7113 12.5393 23.8622 12.0474 24.2018 11.669C24.579 11.3285 25.0317 11.1771 25.5221 11.215C25.9749 11.1771 26.4653 11.3663 26.7671 11.669C26.918 11.8204 27.0312 12.0096 27.1066 12.1987C27.1821 12.3879 27.2198 12.615 27.2198 12.842L27.2575 13.1069ZM28.6911 7.99871H27.4084C27.2952 7.99871 27.2198 8.07438 27.2198 8.1879V10.8366C26.6916 10.1933 25.8617 9.85278 25.0317 9.89062C24.4658 9.89062 23.9377 10.0041 23.4472 10.3068C22.9945 10.5717 22.6173 10.9501 22.3909 11.4041C21.9005 12.4258 21.9005 13.5988 22.3909 14.6204C22.6173 15.0744 22.9568 15.415 23.4095 15.6799C23.8622 15.9447 24.3527 16.0582 24.8808 16.0582C25.3712 16.0582 25.824 15.9826 26.2389 15.7934C26.6539 15.642 26.9934 15.3393 27.2198 14.9988V15.7177C27.2198 15.8312 27.2952 15.9069 27.4084 15.9069H28.6534C28.7665 15.9069 28.842 15.8312 28.842 15.7177V8.1879C28.842 8.15006 28.8043 8.11222 28.8043 8.07438C28.8043 7.99871 28.7288 7.99871 28.6911 7.99871Z",
                        fill: "#353C42"
                    })
                ]
            })
        ]
    }) : null;
};

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Check if the url is active
 * @param pathname The current pathname
 * @param url The href or routerLink to compare
 * @param end If the pathname should end with the url
 * @returns If the url is active
 */ var isActive = function(pathname, url) {
    var end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return url ? end ? pathname.endsWith(url) : pathname.startsWith(url) : false;
};
/**
 * Check if the item is active based on the current url or
 * if any of its children are active
 * Note: active is determined by url containing the pathname as a start or end
 * @param pathname The current pathname
 * @param item The item to check
 * @returns If the item is active
 */ var isItemActive = function(pathname) {
    return function(item) {
        var url = item.href || item.routerLink;
        var hasActiveChild = function() {
            var _item_children;
            var _item_children_some;
            return (_item_children_some = (_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.some(isItemActive(pathname))) !== null && _item_children_some !== void 0 ? _item_children_some : false;
        };
        return url ? isActive(pathname, url, item.end) : hasActiveChild();
    };
};
/**
 * Get the active child
 * @param pathname The current pathname
 * @param children The children to check
 * @returns The active child
 */ var getActiveChild = function(pathname, children) {
    var _children_find;
    return (_children_find = children === null || children === void 0 ? void 0 : children.find(isItemActive(pathname))) !== null && _children_find !== void 0 ? _children_find : null;
};
/**
 * Find the active item with a title
 * @param pathname The current pathname
 * @param items The items to check
 * @param lastFoundTitle The last found title
 * @returns The active item with the last found title
 */ var findActiveItemWithTitle = function(pathname, items, lastFoundTitle) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (item.children) {
                var found = findActiveItemWithTitle(pathname, item.children, item.headerTitle);
                if (found) {
                    return found;
                }
            } else if (isActive(pathname, item.href || item.routerLink, item.end)) {
                return _object_spread_props(_object_spread({}, item), {
                    headerTitle: item.headerTitle || lastFoundTitle
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};

var NavIcon = function(param) {
    var item = param.item, active = param.active, className = param.className;
    return item.icon ? /*#__PURE__*/ jsx(Icon, {
        icon: item.icon,
        className: className
    }) : item.image ? /*#__PURE__*/ jsx("img", {
        src: item.image,
        alt: "",
        className: twMerge("tw-rounded-full", active ? "tw-ring-2 tw-ring-[var(--apollo-layout-highlight)] tw-ring-offset-2" : "", className),
        "aria-hidden": "true"
    }) : null;
};

var NavItem = function(param) {
    var item = param.item, iconOnly = param.iconOnly, beta = param.beta, className = param.className, active = param.active, onItemSelect = param.onItemSelect;
    /**
   * User clicked (or keyboard event) to navigate
   * Notify parent component and report the event
   */ var handleClick = function(item) {
        var _item_trackEvent;
        (_item_trackEvent = item.trackEvent) === null || _item_trackEvent === void 0 ? void 0 : _item_trackEvent.call(item);
        onItemSelect === null || onItemSelect === void 0 ? void 0 : onItemSelect(item);
    };
    return item.routerLink ? /*#__PURE__*/ jsx(NavLink, {
        to: item.routerLink,
        className: twMerge("tw-relative tw-flex tw-items-center tw-px-7 tw-py-3 tw-text-xs", "hover:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] hover:tw-text-[var(--apollo-layout-highlight)]", "focus:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] focus:tw-text-[var(--apollo-layout-highlight)] focus:tw-outline-none", "active:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_30%)] active:tw-text-[var(--apollo-layout-highlight)]", active ? "tw-font-semibold tw-text-[var(--apollo-layout-highlight)]" : "", className),
        title: item.text,
        "data-dgat": item.dgat,
        onClick: function() {
            return handleClick(item);
        },
        children: /*#__PURE__*/ jsx(NavItemContent, {
            item: item,
            active: active,
            iconOnly: iconOnly,
            beta: beta
        })
    }) : item.visible && item.href ? /*#__PURE__*/ jsx("a", {
        href: item.href,
        target: item.target,
        className: twMerge("tw-relative tw-flex tw-items-center tw-pl-7 tw-pr-3 rtl:tw-pl-3 rtl:tw-pr-7 tw-py-3 tw-text-xs", "hover:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] hover:tw-text-[var(--apollo-layout-highlight)]", "focus:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] focus:tw-text-[var(--apollo-layout-highlight)] focus:tw-outline-none", "active:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_30%)] active:tw-text-[var(--apollo-layout-highlight)]", active ? "tw-font-semibold tw-text-[var(--apollo-layout-highlight)]" : "", className),
        title: item.text,
        "data-dgat": item.dgat,
        onClick: function() {
            return handleClick(item);
        },
        children: /*#__PURE__*/ jsx(NavItemContent, {
            item: item,
            active: active,
            iconOnly: iconOnly,
            beta: beta
        })
    }) : null;
};
var NavItemContent = function(param) {
    var item = param.item, active = param.active, iconOnly = param.iconOnly, beta = param.beta;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(NavIcon, {
                item: item,
                active: active,
                className: twJoin("tw-size-6 tw-shrink-0 tw-min-w-6", iconOnly ? "" : "tw-mr-2 rtl:tw-mr-0 rtl:tw-ml-2", item.rtlMirrorIcon ? "rtl:tw-scale-x-[-1]" : "")
            }),
            /*#__PURE__*/ jsx("span", {
                className: twJoin(iconOnly ? "tw-sr-only" : "tw-truncate", (beta === null || beta === void 0 ? void 0 : beta.enabled) && item.isBeta ? "" : "tw-grow"),
                children: item.text
            }),
            (beta === null || beta === void 0 ? void 0 : beta.enabled) && item.isBeta ? /*#__PURE__*/ jsx("div", {
                className: twJoin("tw-grow", iconOnly ? "tw-absolute tw-right-2 tw-top-1 rtl:tw-left-2 rtl:tw-right-auto" : "tw--mt-2 tw-flex tw-self-start"),
                children: /*#__PURE__*/ jsx("div", {
                    className: twJoin("tw-rounded-2xl tw-border tw-border-purple-300 tw-bg-purple-100 tw-px-1 tw-py-0.5 tw-text-[8px] tw-font-extrabold tw-uppercase tw-leading-3 tw-text-purple-800"),
                    children: beta.text
                })
            }) : null,
            active ? /*#__PURE__*/ jsx("div", {
                className: twJoin("tw-absolute tw-inset-y-0 tw-right-0 tw-w-1 tw-rounded-l tw-bg-[var(--apollo-layout-highlight)] rtl:tw-left-0 rtl:tw-right-auto rtl:tw-rounded-l-none rtl:tw-rounded-r")
            }) : null
        ]
    });
};

function _array_like_to_array$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$2(arr, i) {
    return _array_with_holes$2(arr) || _iterable_to_array_limit$2(arr, i) || _unsupported_iterable_to_array$2(arr, i) || _non_iterable_rest$2();
}
function _unsupported_iterable_to_array$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$2(o, minLen);
}
var NavDisclosure = function(param) {
    var item = param.item, beta = param.beta, onItemSelect = param.onItemSelect;
    var _visibleChildren;
    var _useState = _sliced_to_array$2(useState(false), 2), open = _useState[0], setOpen = _useState[1];
    var _useState1 = _sliced_to_array$2(useState(null), 2), activeChild = _useState1[0], setActiveChild = _useState1[1];
    var pathname = useLocation().pathname;
    var handleItemSelect = useCallback(function(item) {
        var _item_trackEvent;
        setOpen(false);
        (_item_trackEvent = item.trackEvent) === null || _item_trackEvent === void 0 ? void 0 : _item_trackEvent.call(item);
        onItemSelect(item);
    }, [
        onItemSelect
    ]);
    var visibleChildren = useCallback(function() {
        var _item_children;
        var isChildVisible = function(child) {
            return child.visible;
        };
        return ((_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.filter(isChildVisible)) || [];
    }, [
        item
    ]);
    useEffect(function() {
        var updateActiveChild = function(url) {
            setActiveChild(item.children ? getActiveChild(url, item.children) : null);
        };
        updateActiveChild(pathname);
    }, [
        pathname,
        item.children
    ]);
    return /*#__PURE__*/ jsxs("div", {
        children: [
            /*#__PURE__*/ jsxs("button", {
                type: "button",
                className: twJoin("tw-flex tw-w-full tw-items-center tw-px-4 tw-py-2 tw-text-left rtl:tw-text-right", "hover:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] hover:tw-text-[var(--apollo-layout-highlight)]", "focus:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] focus:tw-text-[var(--apollo-layout-highlight)] focus:tw-outline-none", "active:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_30%)] active:tw-text-[var(--apollo-layout-highlight)]"),
                "data-dgat": item.dgat,
                hidden: visibleChildren().length === 0,
                onClick: function() {
                    return setOpen(function(open) {
                        return !open;
                    });
                },
                children: [
                    /*#__PURE__*/ jsx(NavIcon, {
                        item: item,
                        active: activeChild !== null,
                        className: "tw-size-6 tw-shrink-0 tw-mr-2 rtl:tw-mr-0 rtl:tw-ml-2"
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: twJoin((beta === null || beta === void 0 ? void 0 : beta.enabled) && item.isBeta ? "" : "tw-grow"),
                        children: item.text
                    }),
                    (beta === null || beta === void 0 ? void 0 : beta.enabled) && item.isBeta ? /*#__PURE__*/ jsx("div", {
                        className: twJoin("tw--mt-2 tw-flex tw-grow tw-self-start"),
                        children: /*#__PURE__*/ jsx("div", {
                            className: twJoin("tw-rounded-2xl tw-border tw-border-purple-300 tw-bg-purple-100 tw-px-1 tw-py-0.5 tw-text-[8px] tw-font-extrabold tw-uppercase tw-leading-3 tw-text-purple-800"),
                            children: beta.text
                        })
                    }) : null,
                    /*#__PURE__*/ jsx(Icon, {
                        icon: "chevron-right",
                        type: "solid",
                        solidSize: "16",
                        className: twJoin("tw-size-4 tw-ml-2 rtl:tw-ml-0 rtl:tw-mr-2", open ? "tw-rotate-90" : "rtl:tw-rotate-180")
                    })
                ]
            }),
            open ? /*#__PURE__*/ jsx("div", {
                children: /*#__PURE__*/ jsx("ul", {
                    className: "tw-flex tw-flex-col",
                    children: (_visibleChildren = visibleChildren()) === null || _visibleChildren === void 0 ? void 0 : _visibleChildren.filter(function(child) {
                        return child.href || child.routerLink;
                    }).map(function(child) {
                        return /*#__PURE__*/ jsx("li", {
                            children: /*#__PURE__*/ jsx(NavItem, {
                                item: child,
                                active: child === activeChild,
                                onItemSelect: function() {
                                    return handleItemSelect(child);
                                },
                                className: "tw-px-12 tw-text-base"
                            })
                        }, child.dgat);
                    })
                })
            }) : null,
            !open && activeChild && (activeChild.href || activeChild.routerLink) ? /*#__PURE__*/ jsx("ul", {
                children: /*#__PURE__*/ jsx("li", {
                    children: /*#__PURE__*/ jsx(NavItem, {
                        item: activeChild,
                        active: true,
                        onItemSelect: function() {
                            return handleItemSelect(activeChild);
                        },
                        className: "tw-px-12 tw-text-base"
                    })
                })
            }) : null
        ]
    });
};

var NavPopover = function(param) {
    var item = param.item, iconOnly = param.iconOnly, beta = param.beta, active = param.active;
    var pathname = useLocation().pathname;
    var handleToggleExpanded = function(item) {
        var _item_trackEvent;
        (_item_trackEvent = item.trackEvent) === null || _item_trackEvent === void 0 ? void 0 : _item_trackEvent.call(item);
    };
    var handleClick = function(child) {
        var _child_trackEvent;
        (_child_trackEvent = child.trackEvent) === null || _child_trackEvent === void 0 ? void 0 : _child_trackEvent.call(child);
    };
    // watchPathname: When route changes, update pathname and trigger re-renders to recalculate which item is active
    var isItemActive$1 = useCallback(function(item) {
        return isItemActive(pathname)(item);
    }, [
        pathname
    ]);
    var visibleChildren = useCallback(function() {
        var _item_children;
        var isChildVisible = function(child) {
            return child.visible;
        };
        return ((_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.filter(isChildVisible)) || [];
    }, [
        item
    ]);
    return /*#__PURE__*/ jsxs(Popover, {
        className: "group",
        children: [
            /*#__PURE__*/ jsxs(PopoverButton, {
                className: twJoin("tw-relative tw-flex tw-w-full tw-items-center tw-py-3 tw-pl-7 tw-pr-3 tw-text-left tw-text-xs rtl:tw-pl-3 rtl:tw-pr-7 rtl:tw-text-right", "hover:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] hover:tw-text-[var(--apollo-layout-highlight)]", "focus:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] focus:tw-text-[var(--apollo-layout-highlight)] focus:tw-outline-none", "active:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_30%)] active:tw-text-[var(--apollo-layout-highlight)]", active ? "tw-font-semibold tw-text-[var(--apollo-layout-highlight)]" : "", "group-data-[open]:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)]"),
                title: item.text,
                "data-dgat": item.dgat,
                hidden: visibleChildren().length === 0,
                onClick: function() {
                    return handleToggleExpanded(item);
                },
                children: [
                    /*#__PURE__*/ jsx(NavIcon, {
                        item: item,
                        active: active,
                        className: twJoin("tw-size-6 tw-min-w-6 tw-shrink-0", iconOnly ? "tw-mr-1 rtl:tw-ml-1 rtl:tw-mr-0" : "tw-mr-2 rtl:tw-ml-2 rtl:tw-mr-0", item.rtlMirrorIcon ? "rtl:tw-scale-x-[-1]" : "")
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: twJoin(iconOnly ? "tw-sr-only" : "tw-truncate", (beta === null || beta === void 0 ? void 0 : beta.enabled) && item.isBeta ? "" : "tw-grow"),
                        children: item.text
                    }),
                    (beta === null || beta === void 0 ? void 0 : beta.enabled) && item.isBeta ? /*#__PURE__*/ jsx("div", {
                        className: twJoin("tw-grow", iconOnly ? "tw-absolute tw-right-2 tw-top-1 rtl:tw-left-2 rtl:tw-right-auto" : "tw--mt-2 tw-flex tw-self-start"),
                        children: /*#__PURE__*/ jsx("div", {
                            className: twJoin("tw-rounded-2xl tw-border tw-border-purple-300 tw-bg-purple-100 tw-px-1 tw-py-0.5 tw-text-[8px] tw-font-extrabold tw-uppercase tw-leading-3 tw-text-purple-800"),
                            children: beta.text
                        })
                    }) : null,
                    /*#__PURE__*/ jsx(Icon, {
                        icon: "chevron-right",
                        className: twJoin("tw-size-3 rtl:tw-rotate-180", iconOnly ? "" : "tw-ml-2 rtl:tw-ml-0 rtl:tw-mr-2")
                    }),
                    active ? /*#__PURE__*/ jsx("div", {
                        className: twJoin("tw-absolute tw-inset-y-0 tw-right-0 tw-w-1 tw-rounded-l tw-bg-[var(--apollo-layout-highlight)] rtl:tw-left-0 rtl:tw-right-auto rtl:tw-rounded-l-none rtl:tw-rounded-r")
                    }) : null
                ]
            }),
            /*#__PURE__*/ jsx(PopoverPanel, {
                className: twJoin("tw-reset tw-ml-2 tw-min-w-60 tw-origin-left tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-white tw-py-2 tw-shadow-xl tw-transition rtl:tw-ml-0 rtl:tw-mr-2 rtl:tw-origin-right", "tw-duration-200 tw-ease-out data-[closed]:tw-scale-95 data-[closed]:tw-opacity-0 data-[closed]:tw-duration-100 data-[closed]:tw-ease-in"),
                transition: true,
                anchor: item.rtlMirrorIcon ? "right start" : "left start",
                children: function(param) {
                    var close = param.close;
                    var _visibleChildren;
                    return /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsx("header", {
                                className: "tw-border-b tw-border-neutral-300 tw-px-4 tw-pb-4 tw-pt-2",
                                children: /*#__PURE__*/ jsx("h4", {
                                    className: "tw-font-extrabold",
                                    children: item.text
                                })
                            }),
                            /*#__PURE__*/ jsx("ul", {
                                className: "tw-flex tw-flex-col",
                                children: (_visibleChildren = visibleChildren()) === null || _visibleChildren === void 0 ? void 0 : _visibleChildren.map(function(child, i) {
                                    return /*#__PURE__*/ jsx("li", {
                                        className: i > 0 && (child === null || child === void 0 ? void 0 : child.includeSeparator) ? "tw-border-t tw-border-neutral-300" : "",
                                        children: (child === null || child === void 0 ? void 0 : child.routerLink) ? /*#__PURE__*/ jsxs(NavLink, {
                                            to: child.routerLink,
                                            className: twMerge("tw-flex tw-items-center tw-px-4 tw-py-2 hover:tw-bg-neutral-100 focus:tw-bg-neutral-100 focus-visible:tw-outline-none", isItemActive$1(child) ? "tw-font-semibold" : ""),
                                            "data-dgat": child.dgat,
                                            onClick: function() {
                                                handleClick(child);
                                                close();
                                            },
                                            children: [
                                                child.icon ? /*#__PURE__*/ jsx(Icon, {
                                                    icon: child.icon,
                                                    type: "solid",
                                                    className: "tw-mr-2 tw-size-6 tw-shrink-0 rtl:tw-ml-2 rtl:tw-mr-0"
                                                }) : null,
                                                /*#__PURE__*/ jsx("span", {
                                                    className: "tw-grow",
                                                    children: child.text
                                                }),
                                                isItemActive$1(child) ? /*#__PURE__*/ jsx(Icon, {
                                                    icon: "check-circle",
                                                    type: "solid",
                                                    className: "tw-ml-4 tw-size-6 tw-shrink-0 tw-text-green-600 rtl:tw-ml-0 rtl:tw-mr-4"
                                                }) : null
                                            ]
                                        }) : child ? /*#__PURE__*/ jsxs("a", {
                                            href: child.href,
                                            target: child.target,
                                            className: twMerge("tw-flex tw-items-center tw-px-4 tw-py-2 hover:tw-bg-neutral-100 focus:tw-bg-neutral-100 focus-visible:tw-outline-none", isItemActive$1(child) ? "tw-font-semibold" : ""),
                                            "data-dgat": child.dgat,
                                            onClick: function() {
                                                handleClick(child);
                                                close();
                                            },
                                            children: [
                                                child.icon ? /*#__PURE__*/ jsx(Icon, {
                                                    icon: child.icon,
                                                    type: "solid",
                                                    className: "tw-mr-2 tw-size-6 tw-shrink-0 rtl:tw-ml-2 rtl:tw-mr-0"
                                                }) : null,
                                                /*#__PURE__*/ jsx("span", {
                                                    className: "tw-grow",
                                                    children: child.text
                                                }),
                                                isItemActive$1(child) ? /*#__PURE__*/ jsx(Icon, {
                                                    icon: "check-circle",
                                                    type: "solid",
                                                    className: "tw-ml-4 tw-size-6 tw-shrink-0 tw-text-green-600 rtl:tw-ml-0 rtl:tw-mr-4"
                                                }) : null
                                            ]
                                        }) : null
                                    }, child.dgat);
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
};

function _array_like_to_array$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$1(arr, i) {
    return _array_with_holes$1(arr) || _iterable_to_array_limit$1(arr, i) || _unsupported_iterable_to_array$1(arr, i) || _non_iterable_rest$1();
}
function _unsupported_iterable_to_array$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$1(o, minLen);
}
var Header = function(param) {
    param.brand; var features = param.features, navigation = param.navigation, className = param.className, onSearch = param.onSearch, onAddContent = param.onAddContent;
    var _features_search, _features_search1, _features_search2, _features_admin, _features_admin1, _features_admin2, _features_addContent, _features_addContent1, _features_addContent2, _features_addContent3, _features_switcher, _features_switcher1, _features_switcher2;
    var searchButtonRef = useRef(null);
    var _useState = _sliced_to_array$1(useState(false), 2), open = _useState[0], setOpen = _useState[1];
    var _useState1 = _sliced_to_array$1(useState(""), 2), title = _useState1[0], setTitle = _useState1[1];
    var actionKey = useActionKey();
    var pathname = useLocation().pathname;
    var handleSearch = function(e) {
        var search = (features === null || features === void 0 ? void 0 : features.search) || {
            enabled: false,
            visible: false
        };
        var enabled = search.enabled && search.visible;
        if (enabled) {
            var _features_search_trackEvent, _features_search;
            features === null || features === void 0 ? void 0 : (_features_search = features.search) === null || _features_search === void 0 ? void 0 : (_features_search_trackEvent = _features_search.trackEvent) === null || _features_search_trackEvent === void 0 ? void 0 : _features_search_trackEvent.call(_features_search);
            onSearch(e);
        }
    };
    var handleAutoClose = function() {
        var isOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        setOpen(isOpen);
    };
    var handleAddContent = function(event) {
        var _features_addContent_trackEvent, _features_addContent;
        onAddContent(event);
        features === null || features === void 0 ? void 0 : (_features_addContent = features.addContent) === null || _features_addContent === void 0 ? void 0 : (_features_addContent_trackEvent = _features_addContent.trackEvent) === null || _features_addContent_trackEvent === void 0 ? void 0 : _features_addContent_trackEvent.call(_features_addContent, event);
    };
    // watchPathname: When route changes, update pathname and trigger re-renders to recalculate which item is active
    var isItemActive$1 = useCallback(function(item) {
        return isItemActive(pathname)(item);
    }, [
        pathname
    ]);
    useEffect(function() {
        var updateTitle = function(url) {
            if (!navigation) return;
            url = url !== null && url !== void 0 ? url : pathname;
            var _navigation_bottom;
            var items = navigation.top.concat((_navigation_bottom = navigation.bottom) !== null && _navigation_bottom !== void 0 ? _navigation_bottom : []);
            var item = findActiveItemWithTitle(url, items);
            setTitle((item === null || item === void 0 ? void 0 : item.headerTitle) || "");
        };
        /**
     * Translate Cmd-K keydown to search button clicks.
     */ var handleKeyDown = function(e) {
            var search = (features === null || features === void 0 ? void 0 : features.search) || {
                enabled: false,
                visible: false
            };
            var enabled = search.enabled && search.visible;
            if (enabled && e.key === "k" && (e.metaKey || e.ctrlKey)) {
                var _searchButtonRef_current;
                e.preventDefault();
                (_searchButtonRef_current = searchButtonRef.current) === null || _searchButtonRef_current === void 0 ? void 0 : _searchButtonRef_current.click();
            }
        };
        var activateKeydown = function(active) {
            if (active) document.addEventListener("keydown", handleKeyDown);
            else document.removeEventListener("keydown", handleKeyDown);
        };
        updateTitle();
        var search = (features === null || features === void 0 ? void 0 : features.search) || {
            enabled: false,
            visible: false
        };
        var enabled = search.enabled && (search.visible || false);
        activateKeydown(enabled);
    }, [
        features === null || features === void 0 ? void 0 : features.search,
        navigation,
        pathname
    ]);
    var _navigation_bottom;
    return /*#__PURE__*/ jsx(Fragment, {
        children: /*#__PURE__*/ jsxs("header", {
            className: twMerge("tw-fixed tw-inset-x-0 tw-top-0", className),
            children: [
                /*#__PURE__*/ jsxs("div", {
                    className: twJoin("tw-relative tw-z-20 tw-flex tw-h-16 tw-items-center tw-gap-4 tw-px-4 tw-transition-shadow tw-duration-200 lg:tw-px-6", "tw-bg-[var(--apollo-layout-background,white)] tw-text-[var(--apollo-layout-text)]", open ? "lg:tw-shadow-sm" : "tw-shadow-sm"),
                    children: [
                        /*#__PURE__*/ jsx("div", {
                            className: "lg:tw-hidden",
                            children: /*#__PURE__*/ jsxs("button", {
                                type: "button",
                                id: "navigation-header-expand-button",
                                className: "tw-btn-medium tw-btn-icon tw-btn-secondary-filled",
                                "aria-expanded": open,
                                onClick: function() {
                                    return handleAutoClose(!open);
                                },
                                children: [
                                    open ? /*#__PURE__*/ jsx(Icon, {
                                        icon: "x-mark",
                                        type: "solid",
                                        solidSize: "16",
                                        className: "tw-size-4"
                                    }) : /*#__PURE__*/ jsx(Icon, {
                                        icon: "bars-3",
                                        type: "solid",
                                        solidSize: "16",
                                        className: "tw-size-4"
                                    }),
                                    /*#__PURE__*/ jsx("span", {
                                        className: "tw-sr-only",
                                        children: open ? "Close Navigation" : "Open Navigation"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ jsx("div", {
                            className: "tw-flex-1 tw-text-center lg:tw-pl-4 lg:tw-text-left rtl:lg:tw-pl-0 rtl:lg:tw-pr-4 rtl:lg:tw-text-right",
                            children: /*#__PURE__*/ jsx("h3", {
                                className: "tw-text-2xl tw-font-bold",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ jsx("div", {
                            className: "tw-hidden tw-flex-1 tw-justify-center lg:tw-flex",
                            children: (features === null || features === void 0 ? void 0 : (_features_search = features.search) === null || _features_search === void 0 ? void 0 : _features_search.enabled) && (features === null || features === void 0 ? void 0 : (_features_search1 = features.search) === null || _features_search1 === void 0 ? void 0 : _features_search1.visible) ? /*#__PURE__*/ jsxs("button", {
                                ref: searchButtonRef,
                                type: "button",
                                id: "navigation-header-search-button",
                                className: twMerge("tw-flex tw-h-10 tw-w-80 tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-neutral-50 tw-px-3 tw-text-left tw-text-neutral-600 tw-ring-1 tw-ring-neutral-300 rtl:tw-text-right", "hover:tw-bg-neutral-100 focus:tw-bg-neutral-100 focus:tw-outline-none active:tw-bg-neutral-200", "[&_*]:tw-pointer-events-none"),
                                onClick: function(e) {
                                    return handleSearch(e);
                                },
                                children: [
                                    /*#__PURE__*/ jsx(Icon, {
                                        icon: "magnifying-glass",
                                        type: "solid",
                                        solidSize: "20",
                                        className: "tw-size-4 tw-shrink-0 rtl:tw-scale-x-[-1]"
                                    }),
                                    /*#__PURE__*/ jsx("span", {
                                        className: "tw-grow",
                                        children: features === null || features === void 0 ? void 0 : (_features_search2 = features.search) === null || _features_search2 === void 0 ? void 0 : _features_search2.text
                                    }),
                                    actionKey ? /*#__PURE__*/ jsxs("kbd", {
                                        className: "tw-font-sans tw-text-xs tw-font-semibold",
                                        children: [
                                            /*#__PURE__*/ jsx("abbr", {
                                                title: actionKey[1],
                                                className: "tw-text-xs tw-no-underline",
                                                children: actionKey[0]
                                            }),
                                            "K"
                                        ]
                                    }) : null
                                ]
                            }) : null
                        }),
                        /*#__PURE__*/ jsxs("div", {
                            className: "tw-flex tw-w-8 tw-justify-end lg:tw-w-auto lg:tw-flex-1",
                            children: [
                                (features === null || features === void 0 ? void 0 : (_features_admin = features.admin) === null || _features_admin === void 0 ? void 0 : _features_admin.enabled) && (features === null || features === void 0 ? void 0 : (_features_admin1 = features.admin) === null || _features_admin1 === void 0 ? void 0 : _features_admin1.visible) ? /*#__PURE__*/ jsx("div", {
                                    className: twJoin("tw-rounded-2xl tw-border tw-border-neutral-300 tw-bg-neutral-100 tw-px-2 tw-py-1 tw-text-xs tw-font-extrabold tw-uppercase tw-text-neutral-800"),
                                    children: features === null || features === void 0 ? void 0 : (_features_admin2 = features.admin) === null || _features_admin2 === void 0 ? void 0 : _features_admin2.text
                                }) : null,
                                (features === null || features === void 0 ? void 0 : (_features_addContent = features.addContent) === null || _features_addContent === void 0 ? void 0 : _features_addContent.enabled) && (features === null || features === void 0 ? void 0 : (_features_addContent1 = features.addContent) === null || _features_addContent1 === void 0 ? void 0 : _features_addContent1.visible) ? /*#__PURE__*/ jsxs("button", {
                                    type: "button",
                                    className: twJoin("tw-btn-medium tw-btn-tertiary", "tw-btn-icon lg:tw-not-btn-icon", "tw-text-[var(--apollo-layout-highlight)]", "hover:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] hover:tw-text-[var(--apollo-layout-highlight)]", "focus:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] focus:tw-text-[var(--apollo-layout-highlight)] focus:tw-outline-none", "active:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_30%)] active:tw-text-[var(--apollo-layout-highlight)]"),
                                    "data-dgat": "utilityBar-fab",
                                    title: features === null || features === void 0 ? void 0 : (_features_addContent2 = features.addContent) === null || _features_addContent2 === void 0 ? void 0 : _features_addContent2.titleText,
                                    onClick: function(e) {
                                        return handleAddContent(e);
                                    },
                                    children: [
                                        /*#__PURE__*/ jsx(Icon, {
                                            icon: "plus",
                                            type: "solid",
                                            solidSize: "16",
                                            className: "tw-size-4"
                                        }),
                                        /*#__PURE__*/ jsx("span", {
                                            className: "tw-sr-only tw-whitespace-nowrap lg:tw-not-sr-only",
                                            children: features === null || features === void 0 ? void 0 : (_features_addContent3 = features.addContent) === null || _features_addContent3 === void 0 ? void 0 : _features_addContent3.text
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ jsxs(Dialog, {
                    open: open,
                    onClose: setOpen,
                    className: "tw-reset tw-relative tw-z-10",
                    children: [
                        /*#__PURE__*/ jsx(DialogBackdrop, {
                            transition: true,
                            className: twJoin("tw-fixed tw-inset-x-0 tw-bottom-0 tw-top-16 tw-bg-neutral-500/75 tw-transition-opacity tw-duration-500 tw-ease-in-out data-[closed]:tw-opacity-0 lg:tw-hidden")
                        }),
                        /*#__PURE__*/ jsx(DialogPanel, {
                            transition: true,
                            className: twJoin("tw-fixed tw-inset-x-0 tw-bottom-0 tw-top-16 tw-transform tw-overflow-y-auto tw-transition lg:tw-hidden", "tw-origin-top tw-duration-500 tw-ease-in-out data-[closed]:tw--translate-y-full"),
                            children: /*#__PURE__*/ jsxs("div", {
                                className: "tw-relative tw-origin-top tw-bg-[var(--apollo-layout-background,white)] tw-text-[var(--apollo-layout-text)] tw-shadow-lg tw-transition",
                                children: [
                                    navigation ? /*#__PURE__*/ jsx("nav", {
                                        children: /*#__PURE__*/ jsx("ul", {
                                            className: "tw-flex tw-flex-col tw-border-t tw-border-neutral-300 tw-pb-4 tw-pt-2",
                                            children: navigation.top.concat((_navigation_bottom = navigation.bottom) !== null && _navigation_bottom !== void 0 ? _navigation_bottom : []).map(function(item) {
                                                var _item_children;
                                                return item.visible ? /*#__PURE__*/ jsxs("li", {
                                                    children: [
                                                        item.href || item.routerLink ? /*#__PURE__*/ jsx(NavItem, {
                                                            item: item,
                                                            active: isItemActive$1(item),
                                                            beta: features === null || features === void 0 ? void 0 : features.beta,
                                                            className: "tw-px-4 tw-text-base",
                                                            onItemSelect: function() {
                                                                return handleAutoClose();
                                                            }
                                                        }) : null,
                                                        ((_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.length) ? /*#__PURE__*/ jsx(NavDisclosure, {
                                                            item: item,
                                                            beta: features === null || features === void 0 ? void 0 : features.beta,
                                                            onItemSelect: function() {
                                                                return handleAutoClose();
                                                            }
                                                        }) : null
                                                    ]
                                                }, item.dgat) : null;
                                            })
                                        })
                                    }) : null,
                                    /*#__PURE__*/ jsx("div", {
                                        className: "tw-border-t tw-border-neutral-300 tw-py-4 tw-text-center",
                                        children: /*#__PURE__*/ jsxs("a", {
                                            href: features === null || features === void 0 ? void 0 : (_features_switcher = features.switcher) === null || _features_switcher === void 0 ? void 0 : _features_switcher.href,
                                            className: "tw-btn-medium tw-btn-tertiary",
                                            "data-dgat": "",
                                            title: features === null || features === void 0 ? void 0 : (_features_switcher1 = features.switcher) === null || _features_switcher1 === void 0 ? void 0 : _features_switcher1.text,
                                            children: [
                                                /*#__PURE__*/ jsx(Icon, {
                                                    icon: "arrows-right-left",
                                                    type: "solid",
                                                    solidSize: "16",
                                                    className: "tw-size-4"
                                                }),
                                                /*#__PURE__*/ jsx("span", {
                                                    className: "tw-whitespace-nowrap",
                                                    children: features === null || features === void 0 ? void 0 : (_features_switcher2 = features.switcher) === null || _features_switcher2 === void 0 ? void 0 : _features_switcher2.text
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};

var Sidebar = function(param) {
    var brand = param.brand, features = param.features, navigation = param.navigation, sidebarExpanded = param.sidebarExpanded, className = param.className, onToggleExpanded = param.onToggleExpanded, onSwitchRole = param.onSwitchRole;
    var _features_switcher, _features_switcher1, _features_switcher2, _features_switcher3, _features_switcher4, _navigation_bottom, _features_sidebarBranding, _features_sidebarBranding1, _features_sidebarBranding2;
    var pathname = useLocation().pathname;
    var handleToggleExpanded = function(e) {
        onToggleExpanded(e);
    };
    var handleBrandClick = function(event) {
        var _brand_trackEvent;
        brand === null || brand === void 0 ? void 0 : (_brand_trackEvent = brand.trackEvent) === null || _brand_trackEvent === void 0 ? void 0 : _brand_trackEvent.call(brand, event);
    };
    var handleSwitchView = function(event) {
        var _features_switcher_trackEvent, _features_switcher;
        features === null || features === void 0 ? void 0 : (_features_switcher = features.switcher) === null || _features_switcher === void 0 ? void 0 : (_features_switcher_trackEvent = _features_switcher.trackEvent) === null || _features_switcher_trackEvent === void 0 ? void 0 : _features_switcher_trackEvent.call(_features_switcher, event);
        onSwitchRole(event);
    };
    // watchPathname: When route changes, update pathname and trigger re-renders to recalculate which item is active
    var isItemActive$1 = useCallback(function(item) {
        return isItemActive(pathname)(item);
    }, [
        pathname
    ]);
    return /*#__PURE__*/ jsx(Fragment, {
        children: /*#__PURE__*/ jsxs("div", {
            className: twMerge("tw-fixed tw-inset-y-0 tw-left-0 tw-shadow-lg rtl:tw-left-auto rtl:tw-right-0", "tw-bg-[var(--apollo-layout-background,white)] tw-text-[var(--apollo-layout-text)]", className),
            children: [
                /*#__PURE__*/ jsx("div", {
                    className: "tw-reset",
                    children: /*#__PURE__*/ jsx("button", {
                        type: "button",
                        className: "tw-btn-icon tw-btn-secondary-outline tw-absolute -tw-right-3 tw-top-6 tw-shadow-lg rtl:-tw-left-3 rtl:tw-right-auto",
                        title: sidebarExpanded ? "Collapse Menu" : "Expand Menu",
                        onClick: function(e) {
                            return handleToggleExpanded(e);
                        },
                        children: /*#__PURE__*/ jsx(Icon, {
                            icon: "chevron-right",
                            type: "solid",
                            solidSize: "16",
                            className: twMerge("tw-size-4", sidebarExpanded ? "tw-rotate-180 rtl:tw-rotate-0" : "rtl:tw-rotate-180")
                        })
                    })
                }),
                brand ? brand.routerLink ? /*#__PURE__*/ jsx(Link, {
                    to: brand.routerLink,
                    "data-dgat": brand.dgat,
                    className: "tw-grid tw-h-20 tw-place-content-center tw-overflow-hidden focus-visible:tw-outline-none",
                    onClick: function(e) {
                        return handleBrandClick(e);
                    },
                    children: /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            sidebarExpanded ? /*#__PURE__*/ jsx("img", {
                                src: brand.logo.url,
                                alt: brand.logo.altText,
                                className: "tw-h-full tw-max-h-8 tw-max-w-[152px]"
                            }) : /*#__PURE__*/ jsx("img", {
                                src: brand.mark.url,
                                alt: brand.mark.altText,
                                className: "tw-size-8"
                            }),
                            /*#__PURE__*/ jsx("span", {
                                className: "tw-sr-only",
                                children: brand.logo.altText
                            })
                        ]
                    })
                }) : brand.href ? /*#__PURE__*/ jsxs("a", {
                    href: brand.href,
                    "data-dgat": brand.dgat,
                    className: "tw-grid tw-h-20 tw-place-content-center tw-overflow-hidden focus-visible:tw-outline-none",
                    onClick: function(e) {
                        return handleBrandClick(e);
                    },
                    children: [
                        sidebarExpanded ? /*#__PURE__*/ jsx("img", {
                            src: brand.logo.url,
                            alt: brand.logo.altText,
                            className: "tw-h-full tw-max-h-8 tw-max-w-[152px]"
                        }) : /*#__PURE__*/ jsx("img", {
                            src: brand.mark.url,
                            alt: brand.mark.altText,
                            className: "tw-size-8"
                        }),
                        /*#__PURE__*/ jsx("span", {
                            className: "tw-sr-only",
                            children: brand.logo.altText
                        })
                    ]
                }) : /*#__PURE__*/ jsxs("div", {
                    "data-dgat": brand.dgat,
                    className: "tw-grid tw-h-20 tw-place-content-center tw-overflow-hidden focus-visible:tw-outline-none",
                    children: [
                        sidebarExpanded ? /*#__PURE__*/ jsx("img", {
                            src: brand.logo.url,
                            alt: brand.logo.altText,
                            className: "tw-h-full tw-max-h-8 tw-max-w-[152px]"
                        }) : /*#__PURE__*/ jsx("img", {
                            src: brand.mark.url,
                            alt: brand.mark.altText,
                            className: "tw-size-8"
                        }),
                        /*#__PURE__*/ jsx("span", {
                            className: "tw-sr-only",
                            children: brand.logo.altText
                        })
                    ]
                }) : null,
                /*#__PURE__*/ jsx("div", {
                    className: twMerge("tw-absolute tw-bottom-0 tw-left-0 tw-top-20 tw-overflow-x-hidden tw-transition-[width] rtl:tw-left-auto rtl:tw-right-0", sidebarExpanded ? "tw-w-[200px]" : "tw-w-20"),
                    children: navigation ? /*#__PURE__*/ jsxs("nav", {
                        className: "tw-flex tw-h-full tw-flex-col tw-pt-4",
                        children: [
                            /*#__PURE__*/ jsx("ul", {
                                className: "tw-flex tw-flex-col tw-gap-2 tw-overflow-y-auto",
                                children: navigation.top.map(function(item) {
                                    var _item_children;
                                    return item.visible ? /*#__PURE__*/ jsxs("li", {
                                        children: [
                                            (item === null || item === void 0 ? void 0 : item.href) || (item === null || item === void 0 ? void 0 : item.routerLink) ? /*#__PURE__*/ jsx(NavItem, {
                                                item: item,
                                                active: isItemActive$1(item),
                                                iconOnly: !sidebarExpanded,
                                                beta: features === null || features === void 0 ? void 0 : features.beta
                                            }) : null,
                                            (item === null || item === void 0 ? void 0 : (_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.length) ? /*#__PURE__*/ jsx(NavPopover, {
                                                item: item,
                                                active: isItemActive$1(item),
                                                iconOnly: !sidebarExpanded,
                                                beta: features === null || features === void 0 ? void 0 : features.beta
                                            }) : null
                                        ]
                                    }, item.dgat) : null;
                                })
                            }),
                            /*#__PURE__*/ jsxs("ul", {
                                className: "tw-flex tw-grow tw-flex-col tw-justify-end tw-gap-2",
                                children: [
                                    (features === null || features === void 0 ? void 0 : (_features_switcher = features.switcher) === null || _features_switcher === void 0 ? void 0 : _features_switcher.enabled) && (features === null || features === void 0 ? void 0 : (_features_switcher1 = features.switcher) === null || _features_switcher1 === void 0 ? void 0 : _features_switcher1.visible) ? /*#__PURE__*/ jsx("li", {
                                        className: "tw-text-center",
                                        children: (features === null || features === void 0 ? void 0 : (_features_switcher2 = features.switcher) === null || _features_switcher2 === void 0 ? void 0 : _features_switcher2.routerLink) ? /*#__PURE__*/ jsxs(Link, {
                                            to: features === null || features === void 0 ? void 0 : (_features_switcher3 = features.switcher) === null || _features_switcher3 === void 0 ? void 0 : _features_switcher3.routerLink,
                                            className: twMerge("tw-btn-medium tw-btn-tertiary tw-transition-[width]", "tw-text-[var(--apollo-layout-highlight)]", "hover:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] hover:tw-text-[var(--apollo-layout-highlight)]", "focus:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] focus:tw-text-[var(--apollo-layout-highlight)] focus:tw-outline-none", "active:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_30%)] active:tw-text-[var(--apollo-layout-highlight)]", sidebarExpanded ? "" : "tw-btn-icon"),
                                            "data-dgat": features.switcher.dgat,
                                            title: features.switcher.text,
                                            onClick: function(e) {
                                                return handleSwitchView(e);
                                            },
                                            children: [
                                                /*#__PURE__*/ jsx(Icon, {
                                                    icon: "arrows-right-left",
                                                    type: "solid",
                                                    solidSize: "16",
                                                    className: "tw-size-4"
                                                }),
                                                /*#__PURE__*/ jsx("span", {
                                                    className: sidebarExpanded ? "tw-whitespace-nowrap" : "tw-sr-only",
                                                    children: features.switcher.text
                                                })
                                            ]
                                        }) : (features === null || features === void 0 ? void 0 : (_features_switcher4 = features.switcher) === null || _features_switcher4 === void 0 ? void 0 : _features_switcher4.href) ? /*#__PURE__*/ jsxs("a", {
                                            href: features.switcher.href,
                                            className: twMerge("tw-btn-medium tw-btn-tertiary tw-transition-[width]", "tw-text-[var(--apollo-layout-highlight)]", "hover:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] hover:tw-text-[var(--apollo-layout-highlight)]", "focus:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] focus:tw-text-[var(--apollo-layout-highlight)] focus:tw-outline-none", "active:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_30%)] active:tw-text-[var(--apollo-layout-highlight)]", sidebarExpanded ? "" : "tw-btn-icon"),
                                            "data-dgat": features.switcher.dgat,
                                            title: features.switcher.text,
                                            onClick: function(e) {
                                                return handleSwitchView(e);
                                            },
                                            children: [
                                                /*#__PURE__*/ jsx(Icon, {
                                                    icon: "arrows-right-left",
                                                    type: "solid",
                                                    solidSize: "16",
                                                    className: "tw-size-4"
                                                }),
                                                /*#__PURE__*/ jsx("span", {
                                                    className: sidebarExpanded ? "tw-whitespace-nowrap" : "tw-sr-only",
                                                    children: features.switcher.text
                                                })
                                            ]
                                        }) : /*#__PURE__*/ jsxs("button", {
                                            type: "button",
                                            className: twMerge("tw-btn-medium tw-btn-tertiary tw-transition-[width]", "tw-text-[var(--apollo-layout-highlight)]", "hover:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] hover:tw-text-[var(--apollo-layout-highlight)]", "focus:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_15%)] focus:tw-text-[var(--apollo-layout-highlight)] focus:tw-outline-none", "active:tw-bg-[rgb(from_var(--apollo-layout-highlight)_r_g_b_/_30%)] active:tw-text-[var(--apollo-layout-highlight)]", sidebarExpanded ? "" : "tw-btn-icon"),
                                            "data-dgat": features.switcher.dgat,
                                            title: features.switcher.text,
                                            onClick: function(e) {
                                                return handleSwitchView(e);
                                            },
                                            children: [
                                                /*#__PURE__*/ jsx(Icon, {
                                                    icon: "arrows-right-left",
                                                    type: "solid",
                                                    solidSize: "16",
                                                    className: "tw-size-4"
                                                }),
                                                /*#__PURE__*/ jsx("span", {
                                                    className: sidebarExpanded ? "tw-whitespace-nowrap" : "tw-sr-only",
                                                    children: features.switcher.text
                                                })
                                            ]
                                        })
                                    }) : null,
                                    (_navigation_bottom = navigation.bottom) === null || _navigation_bottom === void 0 ? void 0 : _navigation_bottom.map(function(item) {
                                        var _item_children;
                                        return item.visible ? /*#__PURE__*/ jsxs("li", {
                                            children: [
                                                (item === null || item === void 0 ? void 0 : item.href) || (item === null || item === void 0 ? void 0 : item.routerLink) ? /*#__PURE__*/ jsx(NavItem, {
                                                    item: item,
                                                    active: isItemActive$1(item),
                                                    iconOnly: !sidebarExpanded,
                                                    beta: features === null || features === void 0 ? void 0 : features.beta
                                                }) : null,
                                                (item === null || item === void 0 ? void 0 : (_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.length) ? /*#__PURE__*/ jsx(NavPopover, {
                                                    item: item,
                                                    active: isItemActive$1(item),
                                                    iconOnly: !sidebarExpanded,
                                                    beta: features === null || features === void 0 ? void 0 : features.beta
                                                }) : null
                                            ]
                                        }, item.dgat) : null;
                                    }),
                                    (features === null || features === void 0 ? void 0 : (_features_sidebarBranding = features.sidebarBranding) === null || _features_sidebarBranding === void 0 ? void 0 : _features_sidebarBranding.enabled) && (features === null || features === void 0 ? void 0 : (_features_sidebarBranding1 = features.sidebarBranding) === null || _features_sidebarBranding1 === void 0 ? void 0 : _features_sidebarBranding1.visible) ? /*#__PURE__*/ jsx("li", {
                                        className: twJoin("tw-border-t tw-border-solid tw-border-neutral-200 tw-pb-4 tw-text-center", sidebarExpanded ? "tw-mx-6" : "tw-mx-3"),
                                        children: /*#__PURE__*/ jsx("div", {
                                            className: "tw-grid tw-place-content-center tw-text-neutral-600",
                                            children: sidebarExpanded ? /*#__PURE__*/ jsxs("div", {
                                                className: "tw-py-4",
                                                children: [
                                                    /*#__PURE__*/ jsx("div", {
                                                        className: "tw-pt-3 tw-text-xs tw-font-semibold",
                                                        children: features === null || features === void 0 ? void 0 : (_features_sidebarBranding2 = features.sidebarBranding) === null || _features_sidebarBranding2 === void 0 ? void 0 : _features_sidebarBranding2.text
                                                    }),
                                                    /*#__PURE__*/ jsx("div", {
                                                        className: "tw-flex tw-h-8 tw-items-center",
                                                        children: /*#__PURE__*/ jsxs("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "93",
                                                            height: "19",
                                                            viewBox: "0 0 93 19",
                                                            fill: "none",
                                                            children: [
                                                                /*#__PURE__*/ jsx("path", {
                                                                    d: "M19.3286 12.8884C18.6747 13.4434 17.8698 13.7965 16.9644 13.7965C15.6566 13.847 14.7512 13.6956 14.2482 12.5857C13.4937 11.0217 13.8961 10.0631 13.9464 9.9118C14.55 8.70097 19.1777 8.39827 19.6304 9.35684C19.9322 9.86135 20.0328 12.1821 19.3286 12.8884ZM8.51391 12.5857C8.0109 13.6956 7.10548 13.847 5.79767 13.7965C4.94255 13.7965 4.08744 13.4938 3.43353 12.8884C2.77962 12.1316 2.82992 9.86135 3.08143 9.35684C3.58443 8.39827 8.1618 8.70097 8.76541 9.9118C8.86601 10.0631 9.26842 11.0217 8.51391 12.5857ZM21.7933 7.6415L15.1536 4.00904L14.9524 3.85769C14.55 3.70633 14.1476 3.70633 13.7955 3.85769L13.544 4.00904L12.4877 4.61445V4.6649L12.8901 4.8667L15.4051 6.22888L16.8638 7.03609C15.4051 7.137 13.9464 7.59105 12.6889 8.29737C12.3368 8.49917 11.8841 8.65052 11.4816 8.65052H11.381C10.9283 8.65052 10.5259 8.54962 10.1738 8.29737C8.86601 7.59105 7.45759 7.137 5.99887 7.03609L11.4313 4.00904L13.3931 2.89912C13.8961 2.54596 14.4997 2.44506 15.1033 2.59641C15.6063 2.79822 16.059 3.00002 16.5117 3.30273C16.7129 3.40363 16.9141 3.45408 17.1153 3.40363C17.3165 3.35318 17.4674 3.25228 17.6183 3.10092C17.7692 2.94957 17.8195 2.69731 17.8195 2.49551C17.8195 2.19281 17.6686 1.8901 17.3668 1.6883C16.7129 1.23424 15.9584 0.931533 15.1536 0.72973C13.3428 0.427024 12.1859 1.28469 11.3307 1.7892C10.2744 0.931534 8.86601 0.527926 7.50789 0.72973C6.70308 0.931533 5.99887 1.23424 5.29466 1.6883C4.89225 1.991 4.74135 2.54596 5.04315 2.94957C5.04315 3.00002 5.09345 3.00002 5.09345 3.05047C5.29466 3.25228 5.54616 3.35318 5.79767 3.35318C5.94857 3.35318 6.09947 3.30273 6.25037 3.20182C6.70308 2.94957 7.15579 2.69731 7.65879 2.49551C8.2624 2.34416 8.91631 2.49551 9.41932 2.84867L1.0191 7.6415C0.817895 7.74241 0.666992 7.99466 0.666992 8.24691V9.40729C0.666992 9.65954 0.817895 9.91179 1.0191 10.0127C1.2203 10.1136 1.2706 10.2145 1.2706 10.6181C1.2706 11.3749 0.767594 15.4109 6.04917 15.4109C10.7774 15.4109 10.2241 10.7695 11.381 10.7695C12.538 10.7695 11.9847 15.4109 16.7129 15.4109C21.9945 15.4109 21.4915 11.3749 21.4915 10.6181C21.4915 10.2145 21.5418 10.1136 21.743 10.0127C21.9945 9.91179 22.1454 9.65954 22.1454 9.40729V8.24691C22.1957 7.99466 22.0448 7.74241 21.7933 7.6415Z",
                                                                    fill: "currentColor"
                                                                }),
                                                                /*#__PURE__*/ jsx("path", {
                                                                    d: "M48.8552 10.6182C48.9055 10.1641 49.1067 9.76049 49.4588 9.45779C49.9618 9.05418 50.5654 8.85238 51.2193 8.90283C51.8229 8.85238 52.4266 9.05418 52.8793 9.45779C53.2314 9.76049 53.4326 10.2146 53.4829 10.6686V11.2236C53.4829 11.6776 53.332 12.1317 53.0302 12.4848C52.9799 12.5353 52.9296 12.6362 52.829 12.6866C52.6278 12.8885 52.326 13.0398 52.0744 13.1407C51.7726 13.2416 51.4205 13.2921 51.0684 13.2921C50.4648 13.3425 49.8612 13.1407 49.4085 12.6866C49.3582 12.6362 49.2576 12.5857 49.2073 12.4848C48.9055 12.0812 48.7546 11.5767 48.8049 11.0722C48.8049 10.9209 48.8049 10.7695 48.8552 10.6182ZM55.4446 7.3893H53.7847C53.7344 7.3893 53.6841 7.43975 53.6338 7.4902C53.5835 7.54065 53.5835 7.59111 53.5835 7.64156V8.44877C53.2817 8.04516 52.829 7.69201 52.3763 7.4902C51.8229 7.2884 51.2696 7.1875 50.666 7.1875C49.9115 7.1875 49.2073 7.33885 48.5534 7.69201C47.9498 7.99471 47.4971 8.49922 47.145 9.10463C46.7929 9.71004 46.642 10.4164 46.642 11.1227C46.642 11.7785 46.7929 12.4344 47.0444 13.0398L47.145 13.1407C47.4468 13.6957 47.9498 14.1497 48.5031 14.5029C48.7546 14.6542 49.0564 14.7551 49.3582 14.856C49.7103 14.9569 50.0624 15.0074 50.4648 14.9569C50.8672 14.9569 51.2696 14.9065 51.672 14.856C51.8732 14.8056 52.0744 14.7047 52.2756 14.6542C52.7787 14.4524 53.2314 14.0993 53.5835 13.6957V14.9065C53.5835 15.2596 53.4829 15.6128 53.2817 15.9155C53.0805 16.2182 52.7787 16.4705 52.4265 16.6218C52.175 16.7227 51.9235 16.8236 51.672 16.8236C51.4708 16.8236 51.3199 16.8741 51.1187 16.8741C50.0121 16.8741 49.3079 16.5714 48.9558 15.9155C48.9558 15.8651 48.9055 15.8146 48.8552 15.8146H47.0947C46.9941 15.8146 46.8935 15.9155 46.8935 16.0164V16.0669C47.0947 16.8236 47.5474 17.429 48.2013 17.8831C49.1067 18.3876 50.1127 18.5894 51.169 18.539C51.9738 18.5894 52.7787 18.3876 53.5332 18.0849C53.5835 18.0849 53.5835 18.0344 53.6338 18.0344C53.9859 17.8831 54.2877 17.6813 54.5392 17.429C55.2434 16.7732 55.6458 15.8651 55.6961 14.9065C55.7464 14.6038 55.7464 14.3011 55.7464 14.0488V7.64156C55.6961 7.4902 55.5955 7.3893 55.4446 7.3893ZM90.4539 11.4758C90.4539 12.0308 90.2527 12.5857 89.8503 12.9389C89.6491 13.1407 89.3473 13.3425 89.0455 13.4434C88.7437 13.5443 88.3916 13.6452 88.0898 13.6452C87.4862 13.6957 86.8322 13.4434 86.4298 13.0398C85.9771 12.5857 85.7759 11.9299 85.8262 11.274C85.7759 10.6182 85.9771 9.9623 86.4298 9.45779C86.9328 9.00373 87.5365 8.80193 88.1904 8.85238C88.794 8.80193 89.4479 9.05418 89.8503 9.45779C90.0515 9.65959 90.2024 9.91185 90.303 10.1641C90.4036 10.4668 90.4539 10.7191 90.4539 11.0218V11.4758ZM92.3653 4.6145H90.6551C90.6048 4.6145 90.5545 4.6145 90.5042 4.66495C90.4539 4.7154 90.4539 4.76586 90.4539 4.81631V8.34787C89.7497 7.4902 88.6934 7.03615 87.5868 7.0866C86.8322 7.0866 86.128 7.23795 85.4741 7.64156C84.8705 7.99471 84.3675 8.49922 84.0657 9.10463C83.7136 9.7605 83.5627 10.5173 83.613 11.274C83.613 12.0308 83.7639 12.7371 84.0657 13.393C84.3675 13.9984 84.8202 14.4524 85.4238 14.8056C86.0274 15.1587 86.6813 15.3101 87.3855 15.3101C88.0395 15.3101 88.6431 15.2092 89.1964 14.9569C89.7497 14.7551 90.2024 14.3515 90.5042 13.8975V14.856C90.5042 15.0074 90.6048 15.1083 90.7557 15.1083H92.4156C92.5665 15.1083 92.6671 15.0074 92.6671 14.856V4.86676C92.6671 4.81631 92.6671 4.7154 92.6168 4.7154C92.5162 4.66495 92.4659 4.6145 92.3653 4.6145ZM75.6152 10.4164C75.6655 9.91185 75.917 9.45779 76.3194 9.20553C76.7721 8.85238 77.3254 8.70103 77.8787 8.70103C78.4823 8.65057 79.0356 8.80193 79.5386 9.15508C79.941 9.45779 80.1926 9.91185 80.1423 10.4164H75.6152ZM81.1483 8.19652C80.2429 7.4902 79.0859 7.0866 77.929 7.1875C77.1242 7.1875 76.3194 7.33885 75.5649 7.74246C74.911 8.09561 74.3577 8.60012 74.0056 9.25598C73.6535 9.91185 73.4523 10.6686 73.4523 11.4254C73.402 12.5353 73.8044 13.5948 74.6092 14.3515C75.5146 15.1083 76.6715 15.4614 77.8787 15.411C78.8847 15.4614 79.8907 15.2596 80.7962 14.7551C81.4501 14.3515 81.9028 13.7461 82.104 12.9894C82.1543 12.8885 82.104 12.7875 82.0034 12.7875H80.2428C80.1925 12.7875 80.0919 12.838 80.0919 12.8885C79.7901 13.4939 79.0859 13.847 78.0296 13.847C77.6272 13.847 77.1745 13.7461 76.7721 13.5948C76.42 13.4434 76.1685 13.1912 75.917 12.8885C75.7158 12.5857 75.6152 12.2326 75.6152 11.8794H82.0034C82.104 11.8794 82.1543 11.829 82.2046 11.7785C82.2549 11.7281 82.3052 11.6272 82.3052 11.5767V11.1731C82.3555 10.0632 81.9028 9.00373 81.1483 8.19652ZM65.6053 10.4164C65.6556 9.91185 65.9071 9.45779 66.3096 9.20553C66.7623 8.85238 67.3156 8.70103 67.8689 8.70103C68.4725 8.65057 69.0258 8.80193 69.5288 9.15508C69.9312 9.45779 70.1827 9.91185 70.1324 10.4164H65.6053ZM71.0881 8.19652C70.1827 7.4902 69.0258 7.0866 67.8689 7.1875C67.0641 7.1875 66.2592 7.33885 65.5047 7.74246C64.8508 8.09561 64.2975 8.60012 63.9454 9.25598C63.5933 9.91185 63.3921 10.6686 63.3921 11.4254C63.3418 12.5353 63.7442 13.5948 64.549 14.3515C65.4544 15.1083 66.6114 15.4614 67.8186 15.411C68.8246 15.4614 69.8306 15.2596 70.736 14.7551C71.3899 14.3515 71.8426 13.7461 72.0438 12.9894C72.0941 12.8885 72.0438 12.7875 71.9432 12.7875H70.1827C70.1324 12.7875 70.0318 12.838 70.0318 12.8885C69.73 13.4939 69.0258 13.847 67.9695 13.847C67.5671 13.847 67.1144 13.7461 66.712 13.5948C66.3599 13.4434 66.1083 13.1912 65.8568 12.8885C65.6556 12.5857 65.555 12.2326 65.555 11.8794H71.9432C72.0438 11.8794 72.0941 11.829 72.1444 11.7785C72.1947 11.7281 72.245 11.6272 72.245 11.5767V11.1731C72.2953 10.0632 71.8929 9.00373 71.0881 8.19652ZM62.4867 7.2884C61.3801 7.2884 60.3741 7.79291 59.6699 8.65057V7.64156C59.6699 7.59111 59.6699 7.54065 59.6196 7.4902C59.5693 7.43975 59.519 7.43975 59.4687 7.3893H57.8087C57.6578 7.3893 57.5572 7.4902 57.5572 7.64156V14.9065C57.5572 15.0578 57.6578 15.1587 57.8087 15.1587H59.519C59.6699 15.1587 59.7705 15.0578 59.7705 14.9065V11.0722C59.7705 10.5677 60.022 10.0632 60.4244 9.71004C60.9274 9.30644 61.5813 9.05418 62.2352 9.10463H62.537C62.6879 9.10463 62.8388 9.00373 62.8388 8.85238V7.54066C62.8388 7.49021 62.7885 7.3893 62.7382 7.33885C62.6879 7.2884 62.6376 7.23795 62.537 7.23795H62.4867V7.2884ZM38.6945 10.4668C38.7448 9.9623 38.9963 9.50824 39.3987 9.25598C39.8514 8.90283 40.4047 8.75147 40.958 8.75147C41.5616 8.70102 42.1149 8.85238 42.6179 9.20553C43.0203 9.50824 43.2215 9.9623 43.2215 10.4668H38.6945ZM44.2275 8.19652C43.3221 7.43975 42.2155 7.0866 41.0586 7.13705C40.2538 7.13705 39.449 7.2884 38.6945 7.69201C38.0405 8.04516 37.4872 8.54967 37.1351 9.20553C36.783 9.8614 36.5818 10.6182 36.5818 11.3749C36.5315 12.4848 36.9339 13.5443 37.7387 14.3011C38.6442 15.0578 39.8011 15.411 41.0083 15.3605C42.0143 15.411 43.0203 15.2092 43.9257 14.7047C44.5796 14.3011 45.0323 13.6957 45.2336 12.9389C45.2839 12.838 45.1832 12.7371 45.1329 12.7371H43.3724C43.3221 12.7371 43.2215 12.7876 43.2215 12.838C42.9197 13.4434 42.2155 13.7966 41.1089 13.7966C40.7065 13.7966 40.2538 13.6957 39.8514 13.5443C39.4993 13.393 39.2478 13.1407 38.9963 12.838C38.7951 12.5353 38.6945 12.1821 38.6945 11.829H45.0323C45.1329 11.829 45.1833 11.7785 45.2336 11.7281C45.2839 11.6776 45.3342 11.5767 45.3342 11.5263V11.1731C45.3845 10.0632 44.982 9.00373 44.2275 8.19652ZM33.0105 11.4758C33.0105 11.7281 32.9602 12.0308 32.8596 12.283C32.759 12.5353 32.6081 12.7875 32.4069 12.9894C32.2057 13.1912 31.9039 13.393 31.6021 13.4939C31.3003 13.5948 30.9481 13.6957 30.596 13.6957C29.9924 13.7461 29.3385 13.4939 28.9361 13.0903C28.4834 12.6362 28.2822 11.9803 28.3325 11.3749C28.2822 10.7191 28.4834 10.0632 28.9361 9.55869C29.4391 9.10463 30.0427 8.90283 30.6966 8.95328C31.3003 8.90283 31.9542 9.15509 32.3566 9.55869C32.5578 9.7605 32.7087 10.0127 32.8093 10.265C32.9099 10.5173 32.9602 10.82 32.9602 11.1227L33.0105 11.4758ZM34.9219 4.66495H33.2117C33.0608 4.66495 32.9602 4.76585 32.9602 4.91721V8.44877C32.256 7.5911 31.1493 7.13705 30.0427 7.1875C29.2882 7.1875 28.584 7.33885 27.9301 7.74246C27.3265 8.09561 26.8235 8.60012 26.5217 9.20553C25.8678 10.5677 25.8678 12.1317 26.5217 13.4939C26.8235 14.0993 27.2762 14.5533 27.8798 14.9065C28.4834 15.2596 29.1373 15.411 29.8415 15.411C30.4954 15.411 31.099 15.3101 31.6524 15.0578C32.2057 14.856 32.6584 14.4524 32.9602 13.9984V14.9569C32.9602 15.1083 33.0608 15.2092 33.2117 15.2092H34.8716C35.0225 15.2092 35.1231 15.1083 35.1231 14.9569V4.91721C35.1231 4.86676 35.0728 4.81631 35.0728 4.76585C35.0728 4.66495 34.9722 4.66495 34.9219 4.66495Z",
                                                                    fill: "currentColor"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ jsx("div", {
                                                className: "tw-pb-5 tw-pt-8",
                                                children: /*#__PURE__*/ jsx("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "40",
                                                    height: "40",
                                                    viewBox: "0 0 40 40",
                                                    fill: "none",
                                                    children: /*#__PURE__*/ jsx("path", {
                                                        fillRule: "evenodd",
                                                        clipRule: "evenodd",
                                                        d: "M35.3277 18.8945L25.3241 13.3547L24.9888 13.1578C24.7094 13.0454 24.402 12.9891 24.0946 12.9891C23.7872 12.9891 23.4799 13.0454 23.2004 13.1578L22.8092 13.3828L21.2444 14.2545C21.2165 14.2827 21.2165 14.3108 21.2444 14.3389L21.8871 14.6764L25.6594 16.7573L27.8949 17.9946C27.8949 17.9946 24.5976 18.1352 21.5518 19.9068C20.9929 20.2443 20.3503 20.413 19.7076 20.413H19.5679C18.9252 20.413 18.2825 20.2443 17.7236 19.9068C14.6778 18.1352 11.3806 17.9946 11.3806 17.9946L19.6237 13.4109L22.5578 11.7518C22.8651 11.5831 23.927 10.9082 25.1285 11.2737C25.6594 11.4143 26.5536 11.9205 27.2801 12.3423C27.8669 12.6798 28.5934 12.5673 29.0405 12.033C29.2641 11.7518 29.3758 11.4425 29.3758 11.105C29.3758 10.627 29.1523 10.177 28.7052 9.89582C27.7551 9.30529 26.4418 8.60227 25.38 8.43354C22.6416 7.95549 20.9091 9.30529 19.5958 10.0083C18.5899 9.1928 16.55 7.98361 13.8396 8.43354C12.7498 8.63039 11.4644 9.30529 10.5143 9.89582C9.78783 10.3458 9.62017 11.3581 10.179 12.0049C10.4585 12.3142 10.8497 12.4829 11.2409 12.4829C11.4923 12.4829 11.7159 12.4267 11.9394 12.2861C12.6659 11.8643 13.5601 11.3581 14.091 11.2175C15.5161 10.8238 16.7456 11.7518 16.7456 11.7518L3.86392 18.8945C3.52861 19.0632 3.33301 19.4288 3.33301 19.7943V21.566C3.33301 21.9315 3.52861 22.269 3.86392 22.4658C4.19924 22.6345 4.28307 22.747 4.28307 23.3938C4.28307 24.5186 3.52861 30.6771 11.5203 30.6771C18.7016 30.6771 17.8075 23.6188 19.5958 23.6469C21.4121 23.6188 20.5179 30.6771 27.6713 30.6771C35.663 30.6771 34.9085 24.5186 34.9085 23.3938C34.9085 22.747 34.9644 22.6627 35.2997 22.4658C35.635 22.2971 35.8307 21.9315 35.8307 21.566V19.7943C35.8586 19.4006 35.635 19.0632 35.3277 18.8945ZM15.2367 26.3746C14.4543 28.0337 13.0851 28.2868 11.1011 28.2025C9.62017 28.1462 8.25097 27.6682 7.55239 26.8527C6.54645 25.6997 6.65822 22.2408 7.04942 21.4816C7.80388 20.0193 14.7337 20.4692 15.6558 22.3252C15.7676 22.5221 16.3824 23.9843 15.2367 26.3746ZM31.6392 26.8527C30.9406 27.64 29.5714 28.1181 28.0905 28.2025C26.1344 28.2868 24.7652 28.0337 23.9549 26.3746C22.8092 23.9843 23.424 22.5221 23.5078 22.3252C24.4299 20.4692 31.3877 20.0193 32.1142 21.4816C32.5334 22.269 32.6452 25.7278 31.6392 26.8527Z",
                                                        fill: "currentColor"
                                                    })
                                                })
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }) : null
                })
            ]
        })
    });
};

var defaultConfiguration = {
    features: {
        search: {
            enabled: false,
            visible: true
        },
        addContent: {
            enabled: false,
            visible: true
        }
    },
    navigation: {
        top: [],
        bottom: []
    }
};

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var Layout = function(param) {
    var children = param.children, className = param.className, configuration = param.configuration, onSearch = param.onSearch, onAddContent = param.onAddContent, onSwitchRole = param.onSwitchRole;
    var _configuration_brand_colors, _configuration_brand, _configuration_brand_colors1, _configuration_brand1, _configuration_brand_colors2, _configuration_brand2, _configuration_brand_colors3, _configuration_brand3, _configuration_features;
    var _useState = _sliced_to_array(useState(false), 2), sidebarExpanded = _useState[0], setSidebarExpanded = _useState[1];
    return /*#__PURE__*/ jsxs("div", {
        style: {
            "--apollo-layout-background": (configuration === null || configuration === void 0 ? void 0 : (_configuration_brand = configuration.brand) === null || _configuration_brand === void 0 ? void 0 : (_configuration_brand_colors = _configuration_brand.colors) === null || _configuration_brand_colors === void 0 ? void 0 : _configuration_brand_colors.background) || "#ffffff",
            "--apollo-layout-text": (configuration === null || configuration === void 0 ? void 0 : (_configuration_brand1 = configuration.brand) === null || _configuration_brand1 === void 0 ? void 0 : (_configuration_brand_colors1 = _configuration_brand1.colors) === null || _configuration_brand_colors1 === void 0 ? void 0 : _configuration_brand_colors1.text) || "var(--apollo-color-neutral-800)",
            "--apollo-layout-highlight": (configuration === null || configuration === void 0 ? void 0 : (_configuration_brand2 = configuration.brand) === null || _configuration_brand2 === void 0 ? void 0 : (_configuration_brand_colors2 = _configuration_brand2.colors) === null || _configuration_brand_colors2 === void 0 ? void 0 : _configuration_brand_colors2.highlight) || "var(--apollo-color-blue-800)",
            "--apollo-layout-separator": (configuration === null || configuration === void 0 ? void 0 : (_configuration_brand3 = configuration.brand) === null || _configuration_brand3 === void 0 ? void 0 : (_configuration_brand_colors3 = _configuration_brand3.colors) === null || _configuration_brand_colors3 === void 0 ? void 0 : _configuration_brand_colors3.separator) || "var(--apollo-color-neutral-200)"
        },
        className: twMerge("tw-bg-neutral-50", className),
        children: [
            /*#__PURE__*/ jsx("a", {
                href: "#main-content",
                className: "tw-sr-only",
                children: "Skip to main content"
            }),
            /*#__PURE__*/ jsx(Header, {
                brand: configuration === null || configuration === void 0 ? void 0 : configuration.brand,
                features: configuration === null || configuration === void 0 ? void 0 : configuration.features,
                navigation: configuration === null || configuration === void 0 ? void 0 : configuration.navigation,
                className: twMerge("tw-reset tw-z-20 tw-transition-[margin]", sidebarExpanded ? "lg:tw-ml-[200px] rtl:lg:tw-ml-0 rtl:lg:tw-mr-[200px]" : "lg:tw-ml-20 rtl:lg:tw-ml-0 rtl:lg:tw-mr-20"),
                onSearch: function(e) {
                    return onSearch === null || onSearch === void 0 ? void 0 : onSearch(e);
                },
                onAddContent: function(e) {
                    return onAddContent === null || onAddContent === void 0 ? void 0 : onAddContent(e);
                }
            }),
            /*#__PURE__*/ jsx(Sidebar, {
                brand: configuration === null || configuration === void 0 ? void 0 : configuration.brand,
                features: configuration === null || configuration === void 0 ? void 0 : configuration.features,
                navigation: configuration === null || configuration === void 0 ? void 0 : configuration.navigation,
                sidebarExpanded: sidebarExpanded,
                className: twMerge("tw-reset tw-z-20 tw-hidden tw-transition-[width] lg:tw-block", sidebarExpanded ? "lg:tw-w-[200px]" : "lg:tw-w-20"),
                onToggleExpanded: function() {
                    return setSidebarExpanded(function(sidebarExpanded) {
                        return !sidebarExpanded;
                    });
                },
                onSwitchRole: function(e) {
                    return onSwitchRole === null || onSwitchRole === void 0 ? void 0 : onSwitchRole(e);
                }
            }),
            /*#__PURE__*/ jsxs("main", {
                id: "main-content",
                className: twMerge("tw-box-border tw-flex tw-min-h-dvh tw-flex-col tw-pt-16 tw-transition-[margin]", sidebarExpanded ? "lg:tw-ml-[200px] rtl:lg:tw-ml-0 rtl:lg:tw-mr-[200px]" : "lg:tw-ml-20 rtl:lg:tw-ml-0 rtl:lg:tw-mr-20"),
                children: [
                    /*#__PURE__*/ jsx("div", {
                        className: "tw-relative tw-grow",
                        children: children
                    }),
                    /*#__PURE__*/ jsx(Footer, {
                        className: "tw-reset",
                        footerBranding: configuration === null || configuration === void 0 ? void 0 : (_configuration_features = configuration.features) === null || _configuration_features === void 0 ? void 0 : _configuration_features.footerBranding
                    })
                ]
            })
        ]
    });
};

/**
 * Calculates the range of buttons for the paginator based on the total number of pages and the current page.
 *
 * For smaller viewport sizes, any total number of pages larger than seven will include ellipses.
 * @param isLargeLayout if '(min-width: 1024px)' is true
 */ function calculatePaginatorButtons(currentPage, pageCount, isLargeLayout) {
    // TODO: Fix a bug where the elipsis is showing multiple times in a row
    if (pageCount === 0) return [];
    if (pageCount < 1) throw new Error("pageCount (".concat(pageCount, ") is out of bounds (1+)"));
    if (currentPage < 1 || currentPage > pageCount) throw new Error("currentPage (".concat(currentPage, ") is out of bounds (1-").concat(pageCount, ")"));
    var getRange = function(start, end) {
        return Array(end - start + 1).fill(0).map(function(v, i) {
            return i + start;
        });
    };
    // Core logic to determine how to build page array
    var delta = 7; // delta === 7: [1 2 3 4 5 6 7]
    if (!isLargeLayout) {
        delta = 1; // delta === 1: [1 2] only show two buttons
    } else if (pageCount > 7) {
        // delta === 2: [1 ... 4 5 6 ... 10]
        // delta === 4: [1 2 3 4 5 ... 10]
        delta = currentPage > 4 && currentPage < pageCount - 3 ? 2 : 4;
    }
    var range = {
        start: Math.round(currentPage - delta / 2),
        end: Math.round(currentPage + delta / 2)
    };
    if (delta > 1 && (range.start - 1 === 1 || range.end + 1 === pageCount)) {
        range.start += 1;
        range.end += 1;
    }
    var pages = currentPage > delta ? getRange(Math.min(range.start, pageCount - delta), Math.min(range.end, pageCount)) : getRange(1, Math.min(pageCount, delta + 1));
    var withDots = function(value, pair) {
        return pages.length + 1 !== pageCount ? pair : [
            value
        ];
    };
    if (delta > 1 && pages[0] !== 1) {
        // -1 represents the "..."
        pages = withDots(1, [
            1,
            -1
        ]).concat(pages);
    }
    if (delta > 1 && pages[pages.length - 1] < pageCount) {
        // -1 represents the "..."
        pages = pages.concat(withDots(pageCount, [
            -1,
            pageCount
        ]));
    }
    return pages;
}

/**
 * Apollo Paginator UI Component
 */ function Paginator(param) {
    var pagination = param.pagination;
    var _window;
    var start = (pagination.currentPage - 1) * pagination.perPage + 1;
    var end = Math.min(pagination.total, start + pagination.perPage - 1);
    var isPageActive = function(page) {
        return page === pagination.currentPage ? "bg-neutral-200 font-semibold" : "hover:bg-neutral-100";
    };
    var _window_matchMedia_matches;
    var isLargeLayout = (_window_matchMedia_matches = (_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia("(min-width: 1024px)").matches) !== null && _window_matchMedia_matches !== void 0 ? _window_matchMedia_matches : false;
    var numPages = pagination.perPage ? Math.ceil(pagination.total / pagination.perPage) : 0;
    var pages = calculatePaginatorButtons(pagination.currentPage, numPages, isLargeLayout);
    return numPages > 1 ? /*#__PURE__*/ jsxs("div", {
        className: "tw-flex tw-h-16 tw-items-center",
        children: [
            /*#__PURE__*/ jsx("div", {
                className: "tw-hidden tw-flex-1 tw-px-6 sm:tw-block",
                children: "Showing ".concat(start, " to ").concat(end, " of ").concat(pagination.total, " results")
            }),
            /*#__PURE__*/ jsxs("div", {
                className: "tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-1 tw-px-6",
                children: [
                    /*#__PURE__*/ jsxs("button", {
                        type: "button",
                        onClick: function() {
                            return pagination.showPage(1);
                        },
                        className: "tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-lg active:tw-bg-neutral-200 enabled:hover:tw-bg-neutral-100 disabled:tw-cursor-not-allowed",
                        children: [
                            /*#__PURE__*/ jsx("span", {
                                className: "tw-sr-only",
                                children: "Previous"
                            }),
                            /*#__PURE__*/ jsx(ChevronDoubleLeftIcon, {
                                className: "tw-h-4 tw-w-4 tw-text-neutral-800",
                                "aria-hidden": "true"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx("button", {
                        type: "button",
                        onClick: function() {
                            return pagination.showPage(pagination.currentPage - 1);
                        },
                        className: "tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-lg active:tw-bg-neutral-200 enabled:hover:tw-bg-neutral-100 disabled:tw-cursor-not-allowed",
                        children: /*#__PURE__*/ jsx(ChevronLeftIcon, {
                            className: "tw-h-4 tw-w-4 tw-text-neutral-800",
                            "aria-hidden": "true"
                        })
                    }),
                    pages.map(function(page) {
                        return /*#__PURE__*/ jsx(Fragment$1, {
                            children: page !== -1 ? // Selected: "bg-neutral-200 font-semibold", Default: "hover:bg-neutral-100"
                            /*#__PURE__*/ jsx("button", {
                                type: "button",
                                onClick: function() {
                                    return pagination.showPage(page);
                                },
                                className: clsx("tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-lg active:tw-bg-neutral-200", isPageActive(page)),
                                children: page
                            }) : /*#__PURE__*/ jsx("span", {
                                className: "tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-lg",
                                children: /*#__PURE__*/ jsx(EllipsisHorizontalIcon, {
                                    className: "tw-h-4 tw-w-4 tw-text-neutral-800",
                                    "aria-hidden": "true"
                                })
                            })
                        }, page);
                    }),
                    /*#__PURE__*/ jsx("button", {
                        type: "button",
                        onClick: function() {
                            return pagination.showPage(pagination.currentPage + 1);
                        },
                        className: "tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-lg active:tw-bg-neutral-200 enabled:hover:tw-bg-neutral-100 disabled:tw-cursor-not-allowed",
                        children: /*#__PURE__*/ jsx(ChevronRightIcon, {
                            className: "tw-h-4 tw-w-4 tw-text-neutral-800",
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ jsx("button", {
                        type: "button",
                        onClick: function() {
                            return pagination.showPage(pagination.lastPage);
                        },
                        className: "tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-lg active:tw-bg-neutral-200 enabled:hover:tw-bg-neutral-100 disabled:tw-cursor-not-allowed",
                        children: /*#__PURE__*/ jsx(ChevronDoubleRightIcon, {
                            className: "tw-h-4 tw-w-4 tw-text-neutral-800",
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsx("div", {
                className: "tw-hidden tw-flex-1 lg:tw-block"
            })
        ]
    }) : null;
}

function Select(param) {
    var id = param.id, name = param.name, options = param.options, value = param.value, disabledOptions = param.disabledOptions, helperText = param.helperText, errorText = param.errorText, multiple = param.multiple, className = param.className, hasError = param.hasError, mode = param.mode, containerId = param.containerId, disabled = param.disabled, onChange = param.onChange, onBlur = param.onBlur;
    var _selectedOptions_;
    // Filter the options to only include those that are selected (if multiple is true) or the one that is selected (if multiple is false), denoted by the 'value' prop.
    var selectedOptions = (options === null || options === void 0 ? void 0 : options.filter(function(option) {
        return Array.isArray(value) ? value === null || value === void 0 ? void 0 : value.includes(option.id) : value === option.id;
    })) || [];
    // Ensure that the selected value is an array if multiple is true, or a single value (or undefined) if multiple is false.
    var selectedValue = multiple ? selectedOptions : selectedOptions.length ? selectedOptions[0] : {};
    var handleChange = function(selectedOptions) {
        var value = multiple ? selectedOptions.map(function(option) {
            return option.id;
        }) : selectedOptions.id;
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    var containerRef = useRef(null);
    var adjustListPosition = useCallback(function() {
        // If the list runs outside the container, move it to open above the button to prevent it from being cut off.
        var container = containerRef.current; // inner div inside the select component
        var list = container === null || container === void 0 ? void 0 : container.querySelector("ul");
        if (!containerId) {
            list.classList.add("top-full");
            return;
        }
        var offsetTop = 0;
        // Traverse to find the relative/absolute container that has the id of 'containerId'
        while(container !== null && (container.id !== containerId || !container.offsetParent)){
            offsetTop += container.offsetTop; // top relative to the closest relative/absolute parent
            container = container.offsetParent; // The next closest relative/absolute parent
        }
        if (container !== null) {
            var listOffsetTop = offsetTop + list.offsetTop;
            var listOffsetHeight = list.offsetHeight;
            var outsideContainer = listOffsetTop + listOffsetHeight > container.offsetHeight;
            list.classList.toggle("top-full", !outsideContainer);
            list.classList.toggle("mb-2", outsideContainer);
            list.classList.toggle("bottom-full", outsideContainer);
        }
    }, [
        containerId
    ]);
    return /*#__PURE__*/ jsx(Listbox, {
        name: name || id,
        value: selectedValue,
        onChange: handleChange,
        multiple: multiple,
        disabled: disabled,
        children: /*#__PURE__*/ jsxs("div", {
            ref: containerRef,
            className: clsx("tw-relative tw-flex group", hasError || errorText ? "tw-has-error" : "", className),
            children: [
                /*#__PURE__*/ jsx(ListboxButton, {
                    className: clsx("tw-btn-secondary-outline group-[.has-error]:tw-bg-danger-50 group-[.has-error]:tw-border-danger-800 group-[.has-error]:tw-text-danger-800 focus:group-[.has-error]:tw-border-danger-800 tw-w-full tw-text-left", mode === "large" ? "tw-btn-medium" : ""),
                    title: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function(option) {
                        return option.name;
                    }).join(", "),
                    onBlur: onBlur,
                    children: /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsx("span", {
                                className: "tw-block tw-flex-1 tw-truncate",
                                children: (selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions_ = selectedOptions[0]) === null || _selectedOptions_ === void 0 ? void 0 : _selectedOptions_.name) || ""
                            }),
                            /*#__PURE__*/ jsx("b", {
                                children: (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 1 ? " +".concat((selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) - 1) : ""
                            }),
                            /*#__PURE__*/ jsx(ChevronUpDownIcon, {
                                className: "tw-h-4 tw-w-4",
                                "aria-hidden": "true"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ jsx(Transition, {
                    leave: "tw-transition tw-duration-100 tw-ease-in",
                    leaveFrom: "tw-opacity-100",
                    leaveTo: "tw-opacity-0",
                    beforeEnter: function() {
                        return adjustListPosition();
                    },
                    children: /*#__PURE__*/ jsx(Listbox.Options, {
                        className: "tw-absolute tw-z-10 tw-mt-1 tw-max-h-40 tw-w-full tw-overflow-auto tw-rounded-xl tw-bg-white tw-py-1 tw-text-base tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none sm:tw-text-sm",
                        children: options === null || options === void 0 ? void 0 : options.map(function(option) {
                            return /*#__PURE__*/ jsx(Listbox.Option, {
                                className: function(param) {
                                    var active = param.active, disabled = param.disabled;
                                    return clsx(active ? "tw-bg-neutral-100 tw-text-neutral-900" : disabled ? "tw-text-neutral-200" : "tw-text-neutral-700", multiple ? "tw-pr-10" : "tw-pr-4", "tw-relative tw-cursor-default tw-select-none tw-py-2 tw-pl-4");
                                },
                                value: option,
                                disabled: disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.includes(option.id),
                                children: function(param) {
                                    var selected = param.selected, disabled = param.disabled;
                                    return /*#__PURE__*/ jsxs(Fragment, {
                                        children: [
                                            /*#__PURE__*/ jsx("span", {
                                                className: clsx(selected ? "tw-font-semibold" : "tw-font-normal", "tw-block tw-truncate"),
                                                children: option.name
                                            }),
                                            multiple ? /*#__PURE__*/ jsx("span", {
                                                className: "tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-4",
                                                children: /*#__PURE__*/ jsx("input", {
                                                    id: "".concat(option.id),
                                                    name: "".concat(option.id),
                                                    type: "checkbox",
                                                    className: "tw-h-4 tw-w-4 tw-rounded tw-border-neutral-200 tw-bg-neutral-100 tw-text-blue-600 focus:tw-ring-blue-600 disabled:tw-border-dashed",
                                                    readOnly: true,
                                                    checked: selected,
                                                    disabled: disabled
                                                })
                                            }) : null
                                        ]
                                    });
                                }
                            }, "".concat(option.id));
                        })
                    })
                }),
                /*#__PURE__*/ jsx("p", {
                    className: "tw-h-5 tw-text-xs tw-leading-5 tw-text-neutral-500 group-[.has-error]:tw-text-red-500 dark:tw-text-neutral-300 dark:group-[.has-error]:tw-text-red-300",
                    children: errorText || helperText
                })
            ]
        })
    });
}

function SimpleConfirmModal(param) {
    var show = param.show, title = param.title, children = param.children, confirmButtonText = param.confirmButtonText, onCancel = param.onCancel, onConfirm = param.onConfirm;
    var cancelButtonRef = useRef(null);
    return /*#__PURE__*/ jsx(Transition, {
        show: show,
        children: /*#__PURE__*/ jsxs(Dialog, {
            as: "div",
            className: "tw-relative tw-z-[60]",
            initialFocus: cancelButtonRef,
            onClose: onCancel,
            children: [
                /*#__PURE__*/ jsx(TransitionChild, {
                    enter: "tw-ease-out tw-duration-300",
                    enterFrom: "tw-opacity-0",
                    enterTo: "tw-opacity-100",
                    leave: "tw-ease-in tw-duration-200",
                    leaveFrom: "tw-opacity-100",
                    leaveTo: "tw-opacity-0",
                    children: /*#__PURE__*/ jsx("div", {
                        className: "tw-fixed tw-inset-0 tw-bg-neutral-600 tw-bg-opacity-75 tw-transition-opacity"
                    })
                }),
                /*#__PURE__*/ jsx("div", {
                    className: "tw-fixed tw-inset-0 tw-z-50 tw-overflow-y-auto",
                    children: /*#__PURE__*/ jsx("div", {
                        className: "tw-flex tw-min-h-full tw-items-end tw-justify-center tw-p-4 tw-text-center sm:tw-items-center sm:tw-p-0",
                        children: /*#__PURE__*/ jsx(TransitionChild, {
                            enter: "tw-ease-out tw-duration-300",
                            enterFrom: "tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95",
                            enterTo: "tw-opacity-100 tw-translate-y-0 sm:tw-scale-100",
                            leave: "tw-ease-in tw-duration-200",
                            leaveFrom: "tw-opacity-100 tw-translate-y-0 sm:tw-scale-100",
                            leaveTo: "tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95",
                            children: /*#__PURE__*/ jsxs(DialogPanel, {
                                className: "tw-relative tw-transform tw-overflow-hidden tw-rounded-lg tw-bg-white tw-px-4 tw-pb-4 tw-pt-5 tw-text-left tw-shadow-xl tw-transition-all sm:tw-my-8 sm:tw-w-full sm:tw-max-w-lg sm:tw-p-6",
                                children: [
                                    /*#__PURE__*/ jsx("div", {
                                        className: "sm:tw-flex sm:tw-items-start",
                                        children: /*#__PURE__*/ jsxs("div", {
                                            className: "tw-mt-3 tw-text-center sm:tw-ml-4 sm:tw-mt-0 sm:tw-text-left",
                                            children: [
                                                /*#__PURE__*/ jsx(Dialog.Title, {
                                                    as: "h4",
                                                    className: "tw-font-extrabold tw-text-neutral-900",
                                                    children: title
                                                }),
                                                /*#__PURE__*/ jsx("div", {
                                                    className: "tw-mt-2",
                                                    children: children
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ jsxs("div", {
                                        className: "tw-mt-5 sm:tw-mt-4 sm:tw-flex sm:tw-flex-row-reverse",
                                        children: [
                                            /*#__PURE__*/ jsx("button", {
                                                type: "button",
                                                className: "tw-btn-primary tw-btn-medium tw-w-full sm:tw-ml-3 sm:tw-w-auto",
                                                onClick: function() {
                                                    return onConfirm();
                                                },
                                                children: confirmButtonText !== null && confirmButtonText !== void 0 ? confirmButtonText : "Confirm"
                                            }),
                                            /*#__PURE__*/ jsx("button", {
                                                type: "button",
                                                className: "tw-btn-secondary-filled tw-btn-medium tw-mt-3 tw-w-full sm:tw-mt-0 sm:tw-w-auto",
                                                onClick: function() {
                                                    return onCancel();
                                                },
                                                ref: cancelButtonRef,
                                                children: "Cancel"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

var SimpleToast = function(param) {
    var title = param.title, children = param.children, _param_type = param.type, type = _param_type === void 0 ? "info" : _param_type, show = param.show, onClose = param.onClose;
    var Icon = ExclamationCircleIcon$1;
    switch(type){
        case "success":
            Icon = CheckCircleIcon;
            break;
        case "warning":
            Icon = ExclamationTriangleIcon;
            break;
        case "info":
        case "primary":
        case "error":
        default:
            Icon = ExclamationCircleIcon$1;
            break;
    }
    var liveNotifications = document.getElementById("live-notifications");
    return liveNotifications ? /*#__PURE__*/ createPortal(/*#__PURE__*/ jsx(Transition, {
        as: "div",
        appear: true,
        show: show,
        enter: "tw-transform tw-ease-out tw-duration-300 tw-transition",
        enterFrom: "tw-translate-y-2 tw-opacity-0 sm:tw-translate-y-0 sm:tw-translate-x-2",
        enterTo: "tw-translate-y-0 tw-opacity-100 sm:tw-translate-x-0",
        leave: "tw-transition tw-ease-in tw-duration-100",
        leaveFrom: "tw-opacity-100",
        leaveTo: "tw-opacity-0",
        className: "tw-pointer-events-auto tw-flex tw-w-full tw-max-w-xs tw-items-start tw-gap-x-3 tw-overflow-hidden tw-rounded-lg tw-bg-white tw-p-4 tw-shadow-xl tw-ring-1 tw-ring-neutral-200",
        children: /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(Icon, {
                    className: clsx(type === "info" ? "tw-text-neutral-600" : "", type === "primary" ? "tw-text-blue-600" : "", type === "success" ? "tw-text-green-600" : "", type === "warning" ? "tw-text-yellow-600" : "", type === "error" ? "tw-text-red-600" : "", "tw-h-6 tw-w-6"),
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ jsxs("div", {
                    className: "tw-flex-1",
                    children: [
                        title ? /*#__PURE__*/ jsx("p", {
                            className: "tw-text-sm tw-font-semibold",
                            children: title
                        }) : null,
                        /*#__PURE__*/ jsx("p", {
                            className: "tw-line-clamp-2 tw-text-xs",
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("button", {
                    type: "button",
                    className: "tw-btn-secondary-filled tw-btn-medium tw-btn-icon",
                    onClick: function() {
                        return onClose();
                    },
                    children: /*#__PURE__*/ jsx(XMarkIcon, {
                        className: "tw-h-4 tw-w-4",
                        "aria-hidden": "true"
                    })
                })
            ]
        })
    }), liveNotifications) : null;
};

export { AcknowledgeModal, DeleteModal, Dropdown, Footer, Header, Icon, Input, Layout, NavDisclosure, NavIcon, NavItem, NavItemContent, NavPopover, Paginator, Select, Sidebar, SimpleConfirmModal, SimpleToast, calculatePaginatorButtons, defaultConfiguration, findActiveItemWithTitle, getActiveChild, isItemActive, twMerge, useActionKey };
